<template>
  <v-layout align-start>
    <template v-if="numeroAsistencia">
      <MiniBitacora
        :numero-asistencia="numeroAsistencia"
        :isShowing="isShowing"
        :noAgregar="showBitacoraLegal"
        @update:isShowing="isShowing = $event"
      />
    </template>
    <v-flex>
      <v-snackbar v-model="snackBarGlobal" color="cyan darken-2" bottom right>{{
        snackBarGlobalText
      }}</v-snackbar>
      <v-data-table
        :headers="headers"
        :items="legalesFiltered"
        :search="search"
        class="elevation-1"
        v-if="verNuevo == 0"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Legales Sin Seguimiento</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="listar()"
                  outlined
                  icon
                  color="green"
                  v-bind="attrs"
                  v-on="on"
                  ><v-icon class="fa fa-sync-alt"></v-icon
                ></v-btn>
              </template>
              <span>Recargar</span>
            </v-tooltip>
            <v-col cols="auto" md="3">
              <v-text-field
                class="text-xs-center ml-5"
                v-model="search"
                append-icon="search"
                label="Busqueda"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="auto" md="3">
              <v-autocomplete
                v-model="selectedUsuario"
                label="Usuario Bitácora"
                :items="usuariosBitacoraLegal"
                dense
                hide-details
              ></v-autocomplete>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" md="1">
              <v-btn @click="listar()" color="blue" dark> Listar </v-btn>
            </v-col>
          </v-toolbar>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-icon small class="mr-2" @click="verDetalles(item)"> tab </v-icon>
          <v-tooltip top color="#6b705c" dark v-if="true">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                class="mr-2"
                color="primary"
                @click="oneDrive(item)"
                v-bind="attrs"
                v-on="on"
              >
                fas fa-cloud
              </v-icon>
            </template>
            <span>Guardar archivos</span>
          </v-tooltip>
        </template>
      </v-data-table>

      <!-- PreLoader -->
      <v-overlay v-model="overlay" z-index="0">
        <lottie-player
          v-if="true"
          src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
          background="transparent"
          speed="1"
          style="width: 300px; height: 300px"
          loop
          autoplay
        ></lottie-player>
      </v-overlay>

      <v-overlay v-model="overlayArchivos" z-index="1">
        <lottie-player
          v-if="true"
          src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
          background="transparent"
          speed="1"
          style="width: 300px; height: 300px"
          loop
          autoplay
        ></lottie-player>
      </v-overlay>

      <v-snackbar
        v-model="snackFechas"
        color="cyan darken-2"
        top
        right
        :timeout="3000"
        >Debe de seleccionar ambas fechas.</v-snackbar
      >

      <v-snackbar v-model="snackError" color="cyan darken-2" top
        >Sucedió algún error, verificar estado de conexión y vuelva a
        intentar.</v-snackbar
      >

      <v-snackbar v-model="snackArchivoSubido" color="cyan darken-2" bottom left
        >LOS ARCHIVOS SE CARGARON CON EXITO.</v-snackbar
      >
      <v-snackbar
        v-model="snackArchivoEliminado"
        color="cyan darken-2"
        bottom
        left
        >ARCHIVOS ELIMINADO CON EXITO.</v-snackbar
      >

      <v-container class="pa-2 white" v-if="verNuevo" fluid>
        <v-form ref="form" v-model="valid">
          <!--Contenedor para cliente -->
          <v-container class="mt-1">
            <v-card
              outlined
              width="100%"
              class="pa-2"
              elevation="1"
              style="border: 1px solid black"
            >
              <v-card-title class="pa-0">
                <v-col> Datos del cliente </v-col>

                <v-spacer></v-spacer>
                <v-col cols="2" align-self="center">
                  <v-text-field
                    v-model="expediente"
                    label="Expediente"
                    readonly
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-card-title>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="placa"
                    label="Placa"
                    clearable
                    :rules="campoRequerido"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="polizaBase"
                    label="Poliza"
                    clearable
                    :rules="campoRequerido"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="marcaBase"
                    label="Marca"
                    clearable
                    :rules="campoRequerido"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="modeloBase"
                    label="Modelo"
                    clearable
                    :rules="campoRequerido"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    type="number"
                    v-model="añoBase"
                    label="Año"
                    clearable
                    :rules="campoRequerido"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="color"
                    label="Color"
                    counter
                    clearable
                    maxlength="35"
                    :rules="campoRequerido"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="usoBase"
                    label="Uso"
                    clearable
                    :rules="campoRequerido"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="titularPolizaBase"
                    label="Titular Poliza"
                    clearable
                    :rules="campoRequerido"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="nombreConductor"
                    label="Nombre conductor"
                    counter
                    maxlength="500"
                    :rules="campoRequerido"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-autocomplete
                    v-model="relacionTitularId"
                    label="Relación con Titular"
                    item-text="nombre"
                    item-value="relacionTitularId"
                    :items="relacionTitular"
                    :rules="campoRequerido"
                    counter
                    clearable
                    maxlength="40"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="numeroTelefono"
                    label="Numero Telefono"
                    counter
                    clearable
                    maxlength="40"
                    :rules="campoRequerido"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-autocomplete
                    v-model="metodoSolicitudAsistencia"
                    label="Método de solicitud"
                    :items="list_metodoSolicitud"
                    counter
                    clearable
                    maxlength="40"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="numeroTelefono2"
                    label="Número de Teléfono (opcional)"
                    counter
                    clearable
                    maxlength="40"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="numeroTelefono3"
                    label="Número de Teléfono (opcional)"
                    counter
                    clearable
                    maxlength="40"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-autocomplete
                    v-model="cartera"
                    :items="list_cartera"
                    item-text="nombre"
                    item-value="nombre"
                    label="Cartera"
                    clearable
                    :rules="campoRequerido"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="3" v-if="cartera == 'VANGRUPO'">
                  <v-text-field
                    v-model="vanGrupoId"
                    label="ID_UUID"
                    readonly
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="vanGrupoEmpresa"
                    label="VanGrupo Empresa"
                    readonly
                    outlined
                    dense
                  ></v-text-field>
                </v-col>

                <v-col cols="auto">
                  <v-spacer></v-spacer>
                  <v-checkbox
                    v-model="checkboxRapiAssaSegunPlataforma"
                    class="mt-0 mr-3"
                    label="RAPIASSA SEGÚN PLATAFORMA"
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" md="4" v-if="errorPlaca">
                  <div class="red--text" v-text="errorPlaca"></div>
                </v-col>
              </v-row>
            </v-card>
          </v-container>
          <!--Contenedor para datos del servicio -->
          <v-container class="mt-1">
            <v-card
              outlined
              width="100%"
              class="pa-2"
              elevation="1"
              style="border: 1px solid black"
            >
              <v-card-title class="pa-0">Datos del servicio</v-card-title>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="fechaHoraOcurrencia"
                    label="Fecha Ocurrencia"
                    type="datetime-local"
                    step="1"
                    clearable
                    :rules="campoRequerido"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-autocomplete
                    v-model="proveedor"
                    :items="list_proveedor"
                    item-text="nombre"
                    item-value="idProveedor"
                    label="Proveedor"
                    @input="autoCompFechaAsignacion()"
                    clearable
                    :rules="campoRequerido"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                  md="2"
                  class="d-flex justify-center align-center"
                >
                  <v-switch
                    v-model="fueraTurno"
                    inset
                    class="pt-0 mt-3"
                    color="primary"
                    label="Fuera de Turno"
                  ></v-switch>
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="fechaHoraAsignacion"
                    label="Fecha Asignacion"
                    step="1"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="2" class="align-self-center">
                  <v-autocomplete
                    v-model="pais"
                    :items="list_pais"
                    label="Pais"
                    clearable
                    :rules="campoRequerido"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="3" class="align-self-center">
                  <v-autocomplete
                    v-model="depaSiniestro"
                    :items="list_depaSiniestro"
                    label="Departamento Siniestro"
                    clearable
                    @input="listaMunicipioSiniestro"
                    persistent-hint
                    :rules="campoRequerido"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="3" class="align-self-center">
                  <v-autocomplete
                    v-model="muniSiniestro"
                    :items="list_muniSiniestro"
                    label="Municipio Siniestro"
                    :background-color="colorSiniestro"
                    clearable
                    :rules="campoRequerido"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="4">
                  <v-textarea
                    v-model="comDireccionSiniestro"
                    label="Complemento Direccion Siniestro"
                    counter
                    maxlength="1000"
                    auto-grow
                    row-height="0"
                    outlined
                    :rules="campoRequerido"
                  ></v-textarea>
                </v-col>
                <v-col cols="12" md="3">
                  <v-autocomplete
                    v-model="tipoAsistencia"
                    :items="list_tipoAsistencia"
                    item-text="nombre"
                    item-value="nombre"
                    label="Tipo De Asistencia"
                    clearable
                    :rules="campoRequerido"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="2" v-if="tipoAsistencia == 'QUEJA'">
                  <v-autocomplete
                    v-model="tipoQuejaId"
                    label="Tipo Queja"
                    item-text="tipo"
                    item-value="tipoQuejaId"
                    :items="tipoQueja"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                  md="2"
                  v-if="tipoAsistencia == 'INSPECCION ON LINE'"
                >
                  <v-autocomplete
                    v-model="tipoInspeccionId"
                    label="¿Por qué no se dio inspección en línea?"
                    item-text="tipo"
                    item-value="tipoInspeccionId"
                    :items="tipoInspeccionOnline"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" :md="tipoAsistencia == 'QUEJA' ? '2' : '3'">
                  <v-text-field
                    v-model="pretencionInicial"
                    label="Pretención inicial"
                    type="number"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" :md="tipoAsistencia == 'QUEJA' ? '2' : '3'">
                  <v-text-field
                    v-model="pretencionFinal"
                    label="Pretención final"
                    type="number"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3" class="align-self-center">
                  <v-autocomplete
                    v-model="causa"
                    :items="list_causa"
                    label="Causa"
                    clearable
                    :rules="campoRequerido"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="4" class="align-self-center">
                  <v-autocomplete
                    v-model="depaOrigen"
                    :items="list_depaOrigen"
                    label="Departamento Origen"
                    clearable
                    @input="listaMunicipioOrigen"
                    persistent-hint
                    :rules="campoRequerido"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="4" class="align-self-center">
                  <v-autocomplete
                    v-model="muniOrigen"
                    :items="list_muniOrigen"
                    label="Municipio Origen"
                    :background-color="colorOrigen"
                    clearable
                    :rules="campoRequerido"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="4">
                  <v-textarea
                    v-model="comDireccionOrigen"
                    label="Complemento Direccion Origen"
                    counter
                    maxlength="1000"
                    auto-grow
                    row-height="0"
                    outlined
                    :rules="campoRequerido"
                  ></v-textarea>
                </v-col>
                <v-col cols="12" md="4" class="align-self-center">
                  <v-autocomplete
                    v-model="depaDestino"
                    :items="list_depaDestino"
                    label="Departamento Destino"
                    clearable
                    @input="listaMunicipioDestino"
                    persistent-hint
                    :rules="campoRequerido"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="4" class="align-self-center">
                  <v-autocomplete
                    v-model="muniDestino"
                    :items="list_muniDestino"
                    label="Municipio Destino"
                    :background-color="colorDestino"
                    clearable
                    :rules="campoRequerido"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="4">
                  <v-textarea
                    v-model="comDireccionDestino"
                    label="Complemento Direccion Destino"
                    counter
                    maxlength="1000"
                    auto-grow
                    row-height="0"
                    outlined
                    :rules="campoRequerido"
                  ></v-textarea>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="placaContraparte"
                    label="Placa Contraparte"
                    counter
                    maxlength="35"
                    :rules="campoRequerido"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-btn
                    color="primary"
                    block
                    :disabled="btnConsulta"
                    @click="autoCompConsultaAseguradora"
                    >Consulta Aseguradora <i class="fas fa-chevron-right"></i>
                  </v-btn>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="horaConsultaAseguradora"
                    label="Consulta Aseguradora"
                    dense
                    hide-details
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-btn
                    color="primary"
                    block
                    :disabled="btnConfirmacion"
                    @click="autoCompConfirmacionAseguradora"
                    >Confirmación Aseguradora
                    <i class="fas fa-chevron-right"></i>
                  </v-btn>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="horaConfirmacionAseguradora"
                    label="Confirmación Aseguradora"
                    dense
                    hide-details
                    readonly
                  ></v-text-field>
                </v-col>
                <v-spacer></v-spacer>
                <v-col
                  cols="12"
                  md="4"
                  v-if="$store.state.usuario.rol == 'Admin Proveedores'"
                >
                  <v-autocomplete
                    v-model="descuentoId"
                    label="Descuento"
                    item-text="nombre"
                    item-value="descuentoId"
                    :items="descuentos"
                    clearable
                  >
                    <template v-slot:item="{ item }">
                      {{ `${item.nombre} (${item.porcentaje * 100}%)` }}
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-card>
          </v-container>
          <!-- Contenedor para finalizacion del servicio -->
          <v-container class="my-1">
            <v-card
              outlined
              width="100%"
              class="pa-2"
              elevation="1"
              style="border: 1px solid black"
            >
              <v-card-title class="pa-0"
                >Finalización del servicio</v-card-title
              >
              <v-row>
                <v-col cols="12" :md="localForaneo == 'FORANEO' ? 2 : 4">
                  <v-tooltip bottom color="primary" v-if="descuentoId != null">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        type="number"
                        v-on="on"
                        v-bind="attrs"
                        v-model="costoServicio"
                        label="Costo Servicio"
                        :readonly="costoEncontrado && !desbloquearCostoServicio"
                        :disabled="costoValid && !desbloquearCostoServicio"
                        :rules="campoRequerido"
                      ></v-text-field>
                    </template>
                    <div class="d-inline-flex">
                      <div class="text-right mr-2">
                        <p class="no-padding-and-margin">
                          Costo Sin Descuento:
                        </p>
                        <p class="no-padding-and-margin">Total Descuento:</p>
                        <p class="no-padding-and-margin">
                          Porcentaje Descuento:
                        </p>
                        <p class="no-padding-and-margin">Recupero:</p>
                      </div>
                      <div class="text-center">
                        <p class="no-padding-and-margin">
                          {{ costoSinDescuento }}
                        </p>
                        <p class="no-padding-and-margin">
                          {{ totalDescuento }}
                        </p>
                        <p class="no-padding-and-margin">
                          {{ getPorcentajeDescuento }}
                        </p>
                        <p class="no-padding-and-margin">
                          {{ getPorcentajeRecupero }}
                        </p>
                      </div>
                    </div>
                  </v-tooltip>
                  <v-text-field
                    v-else
                    type="number"
                    v-model="costoServicio"
                    label="Costo Servicio"
                    :readonly="costoEncontrado && !usuariosCostoDesbloqueado"
                    :disabled="costoValid && !desbloquearCostoServicio"
                    :rules="campoRequerido"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="2" v-if="localForaneo == 'FORANEO'">
                  <v-text-field
                    v-model="kmCosto"
                    label="Kilometros"
                    :disabled="costoValid && !desbloquearCostoServicio"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="2" class="pt-6">
                  <v-btn
                    outlined
                    color="primary"
                    :disabled="costoValid && !desbloquearCostoServicio"
                    @click="calcularCosto"
                    >Calcular Costo</v-btn
                  >
                </v-col>
                <v-col cols="12" md="3" class="mb-6 align-self-center">
                  <v-autocomplete
                    v-model="tipoServicio"
                    :items="list_tipoServicio"
                    label="Tipo Servicio"
                    clearable
                    :rules="campoRequerido"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="3" class="mb-6 align-self-center">
                  <v-autocomplete
                    v-model="estatusAsistencia"
                    :items="list_estatusAsistencia"
                    item-text="estado"
                    item-value="estado"
                    label="Estatus Asistencia"
                  ></v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                  md="7"
                  class="align-self-center mb-6 pt-0"
                  v-if="estatusAsistencia == 'CANCELADO A SOLICITUD'"
                >
                </v-col>
                <v-col
                  cols="12"
                  md="5"
                  class="align-self-center mb-6 pt-0"
                  v-if="estatusAsistencia == 'CANCELADO A SOLICITUD'"
                >
                  <v-form ref="fObsCancelacion">
                    <v-autocomplete
                      v-model="selectedObsCanceclacion"
                      :items="observacionesCancelacion"
                      :rules="
                        estatusAsistencia == 'CANCELADO A SOLICITUD'
                          ? campoRequerido
                          : []
                      "
                      item-text="observacion"
                      item-value="observacion"
                      label="Observación Cancelación"
                    ></v-autocomplete>
                  </v-form>
                </v-col>
                <v-col cols="12" md="2">
                  <v-btn
                    color="primary"
                    block
                    :disabled="btnContacto || fechaHoraAsignacion == null"
                    @click="autoCompFechaContacto"
                    >Contacto <i class="fas fa-chevron-right"></i>
                  </v-btn>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="fechaHoraContacto"
                    label="Fecha Contacto"
                    step="1"
                    :disabled="
                      textFieldContactoDisabled || fechaHoraAsignacion == null
                    "
                    :rules="campoRequerido"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-btn
                    color="primary"
                    block
                    :disabled="
                      (tipoAsistencia == 'LEGAL' &&
                        $store.state.usuario.idUsuario != 1063 &&
                        $store.state.usuario.idUsuario != 1035) ||
                      btnFinalizado ||
                      fechaHoraContacto == null
                    "
                    @click="autoCompFinalizado"
                    >Termino <i class="fas fa-chevron-right"></i
                  ></v-btn>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="termino"
                    label="Termino"
                    step="1"
                    :disabled="
                      textFieldTerminoDisabled || fechaHoraContacto == null
                    "
                    clearable
                    :rules="campoRequerido"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="cabinistaContacto"
                    label="Cabinista que establecio contacto"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="cabinistaTermino"
                    label="Cabinista que establecio termino"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-textarea
                    v-model="obsAdicionales"
                    label="Observaciones Adicionales"
                    counter
                    maxlength="4000"
                    auto-grow
                    row-height="0"
                    outlined
                    :rules="campoRequerido"
                  ></v-textarea>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="operador" label="Operador" disabled>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model.trim="quienSolicita"
                    label="Quién Solicita/Autoriza"
                    clearable
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="fechaSolicitudAjuste"
                    label="Fecha de solicitud de ajuste"
                    type="datetime-local"
                    step="1"
                    clearable
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-autocomplete
                    v-model="localForaneo"
                    :items="list_localForaneo"
                    label="Local/Foraneo"
                    clearable
                    :rules="campoRequerido"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="4" v-if="quienSolicita">
                  <v-form ref="fComentarioAutoriza">
                    <v-textarea
                      v-model="comentarioAutoriza"
                      label="Comentario Autorización"
                      counter
                      maxlength="500"
                      :rules="quienSolicita ? campoRequerido : []"
                      no-resize
                      rows="4"
                      outlined
                    ></v-textarea>
                  </v-form>
                </v-col>
                <v-col cols="12" md="2">
                  <v-checkbox
                    v-model="partePolicial"
                    label="Hay Parte Policial?"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" md="2">
                  <v-checkbox
                    v-model="seMovioDelLugar"
                    label="Se Movio Del lugar"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" md="2">
                  <v-checkbox
                    v-model="zonaPeligrosa"
                    label="zona Peligrosa"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" md="2">
                  <v-checkbox
                    v-model="reporteTardio"
                    label="Reporte Tardio"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" md="2">
                  <v-checkbox
                    v-model="roboRecuperado"
                    label="Robo Recuperado"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" md="3">
                  <v-checkbox
                    v-model="estadoEbriedad"
                    label="Estado de ebriedad"
                  >
                  </v-checkbox>
                </v-col>
                <v-col cols="auto">
                  <v-radio-group v-model="radioGroupRecobroConciliacion">
                    <v-radio label="Recupero" value="Recupero"></v-radio>
                    <v-radio label="Recobro" value="Recobro"></v-radio>
                    <v-radio
                      label="Conciliación"
                      value="Conciliación"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col
                  cols="12"
                  sm="2"
                  md="3"
                  v-if="radioGroupRecobroConciliacion"
                >
                  <v-text-field
                    v-model="cantRecupero"
                    type="number"
                    :readonly="
                      cantRecuperoEncontrado && !desbloquearCantRecobro
                    "
                    label="Valor"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="2"
                  md="2"
                  v-if="radioGroupRecobroConciliacion == 'Recupero'"
                >
                  <v-text-field
                    type="number"
                    label="Porcentaje Recupero (5%)"
                    :value="getPorcentajeRecupero"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-checkbox v-model="protocolo" label="Protocolo">
                  </v-checkbox>
                </v-col>
                <v-col cols="12" md="2">
                  <v-checkbox v-model="pasaFiscalia" label="Pasa a fiscalia">
                  </v-checkbox>
                </v-col>
                <v-col cols="12" md="2">
                  <v-checkbox
                    v-model="reembolso"
                    label="Reembolso"
                  ></v-checkbox>
                </v-col>
                <v-row class="mx-0">
                  <template v-if="radioGroupRecobroConciliacion == 'Recupero'">
                    <v-col cols="12" md="3">
                      <v-text-field
                        class="mb-2"
                        dense
                        label="DUI Persona Recupero"
                        v-mask="'########-#'"
                        v-model="DUIPersonaRecupero"
                        hint="01234567-8"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        class="mb-2"
                        dense
                        label="Nombre Persona Recupero"
                        v-model="personaRecupero"
                        hint="Nombre que aparece en DUI"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3"></v-col>
                  </template>
                  <v-col cols="12" md="2">
                    <v-btn
                      color="primary"
                      block
                      :disabled="btnCierreFinalizado"
                      @click="autoCompCierreFinalizado()"
                      >Cierre Asistencia <i class="fas fa-chevron-right"></i
                    ></v-btn>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="fechaHoraCierreAsistencia"
                      label="Fecha Cierre Asistencia"
                      step="1"
                      persistent-hint
                      clearable
                      :disabled="textFieldCierreDisabled"
                      :rules="campoRequerido"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="7">
                    <v-text-field
                      v-model="cabinistaCierre"
                      label="Cabinista que establecio cierre de asistencia"
                      disabled
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mx-0">
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="numeroCheque"
                      label="Número de cheque"
                      clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="responsable"
                      label="Quien es el responsable"
                      clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="fechaHoraProgramado"
                      label="Fecha programado"
                      type="datetime-local"
                      step="1"
                      clearable
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-row>
            </v-card>
          </v-container>
          <!-- Campos para agregar datos por parte del ajustador -->
          <v-container class="mt-1">
            <v-card
              outlined
              width="100%"
              class="pa-2"
              elevation="1"
              style="border: 1px solid black"
            >
              <v-card-title class="pa-0">Datos Ajustador</v-card-title>
              <v-row>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="expedienteAssa"
                    label="EXPEDIENTE ASSA"
                    clearable
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-autocomplete
                    v-model="inspeccionInSituVirtual"
                    label="INSPECCIÓN IN SITU O VIRTUAL"
                    :items="list_inspeccionInSituVirtual"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="3">
                  <v-autocomplete
                    v-model="rapiAssaAsegurado"
                    label="RAPIASSA ASEGURADO"
                    :items="list_rapiAssaAsegurado"
                    counter="12"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="3">
                  <v-autocomplete
                    v-model="rapiAssaTercero"
                    label="RAPIASSA TERCERO"
                    :items="list_rapiAssaTercero"
                    counter="12"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="3">
                  <v-autocomplete
                    v-model="motivoNoUsoRapiassa"
                    label="MOTIVO DE NO USO RAPIASSA"
                    :items="list_motivoNoUsoRapiassa"
                    counter="200"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="3">
                  <v-autocomplete
                    v-model="motivoNoUsoRapiassaTercero"
                    label="MOTIVO DE NO USO RAPIASSA TERCERO"
                    :items="list_motivoNoUsoRapiassa"
                    counter="200"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="3">
                  <v-autocomplete
                    v-model="usoGruaAsegurado"
                    label="USÓ DE GRÚA ASEGURADO"
                    :items="list_usoGruaAsegurado"
                    counter="12"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="3">
                  <v-autocomplete
                    v-model="usoGruaTercero"
                    label="USÓ DE GRÚA TERCERO"
                    :items="list_usoGruaAsegurado"
                    counter="12"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="3">
                  <v-autocomplete
                    v-model="tallerAsegurado"
                    label="TALLER ASEGURADO"
                    :items="list_redTalleres"
                    counter="50"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="3">
                  <v-autocomplete
                    v-model="tallerTercero"
                    label="TALLER TERCERO"
                    :items="talleresCartera"
                    counter="50"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="2">
                  <v-autocomplete
                    v-model="estadoVirtual"
                    label="ESTADO VIRTUAL"
                    :items="list_estadoVirtual"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="4">
                  <v-autocomplete
                    v-model="motivoDeNoUsoTaller"
                    label="MOTIVO DE NO USO TALLER"
                    :items="list_motivoDeNoTaller"
                    counter="50"
                    clearable
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="3">
                  <v-autocomplete
                    v-model="declinaciones"
                    :items="itemsDeclinaciones"
                    label="Declinaciones"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="ahorroDe"
                    label="Ahorro de $"
                    type="number"
                  ></v-text-field>
                </v-col>
                <v-col v-if="cartera == 'SISA SEGUROS'" cols="12" md="auto">
                  <v-autocomplete
                    v-model="tallerId"
                    label="Taller SISA"
                    item-text="nombre"
                    item-value="id"
                    :items="talleresSISA"
                    clearable
                  >
                  </v-autocomplete>
                </v-col>
                <v-col v-if="cartera == 'SISA SEGUROS'" cols="12" md="auto">
                  <v-autocomplete
                    v-model="analistasSISAId"
                    label="Analista SISA"
                    item-text="nombre"
                    item-value="analistaId"
                    :items="analistasSISA"
                    clearable
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-card>
          </v-container>
        </v-form>
        <!-- Contenedor para agregar y descargar imagenes -->
        <v-container class="mt-1" v-if="verNuevo == 1">
          <v-card
            outlined
            width="100%"
            class="pa-2 mb-1"
            elevation="1"
            style="border: 1px solid black"
          >
            <v-card-title class="pa-0">Almacenamiento de imagenes</v-card-title>
            <v-row justify="center" align="center">
              <v-col cols="auto">
                <v-card max-width="500">
                  <v-card-title>Cargar archivos</v-card-title>
                  <v-card-actions>
                    <v-file-input
                      v-model="filesCargadas"
                      id="fileButtom"
                      accept="image/*, .mp3, .wav, .pdf"
                      label="File input"
                      multiple
                      small-chips
                      :show-size="1000"
                      counter
                      @change="cargarArchivos()"
                    ></v-file-input>
                    <v-btn
                      :disabled="disabledCargarArchivos"
                      class="mx-auto"
                      rounded
                      outlined
                      elevation="3"
                      color="blue"
                      @click="subirArchivos()"
                    >
                      <i class="fas fa-cloud-upload-alt fa-2x"></i>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="auto">
                <v-card max-width="500">
                  <v-card-title>Ver archivos</v-card-title>
                  <v-row justify="center">
                    <v-btn
                      rounded
                      outlined
                      elevation="5"
                      color="blue"
                      class="mb-3"
                      @click="contarArchivosDescarga()"
                      ><i class="fas fa-cloud-download-alt fa-2x"></i
                    ></v-btn>
                  </v-row>
                </v-card>
              </v-col>
              <v-col cols="12" v-if="imagenesPreview.length > 0">
                <v-sheet elevation="8">
                  <div>
                    <v-btn
                      class="ml-4 mt-4"
                      outlined
                      rounded
                      color="blue"
                      @click="descargarZIP()"
                      v-if="mostrarBotonDescargar"
                      >Descargar imagenes</v-btn
                    >
                  </div>
                  <v-slide-group
                    v-model="model"
                    class="pl-4 pr-4 pb-4 pt-0"
                    center-active
                    show-arrows
                  >
                    <v-slide-item
                      v-for="(item, i) in imagenesPreview"
                      :key="i"
                      v-slot="{ toggle }"
                    >
                      <v-card
                        class="ma-4"
                        height="200"
                        width="150"
                        @click="toggle"
                      >
                        <v-row class="fill-height" justify="center">
                          <v-scale-transition>
                            <v-img
                              :src="item.url"
                              @click="verImagen(item)"
                            ></v-img>
                          </v-scale-transition>
                        </v-row>
                      </v-card>
                    </v-slide-item>
                  </v-slide-group>
                </v-sheet>
              </v-col>
              <v-col cols="12" v-if="filesDescargadasAudios.length > 0">
                <v-sheet elevation="8">
                  <div>
                    <v-btn
                      class="ml-4 mt-4"
                      outlined
                      rounded
                      color="blue"
                      @click="descargarZipAudios()"
                      v-if="mostrarBotonDescargar"
                      >Descargar audios</v-btn
                    >
                  </div>
                  <v-slide-group
                    v-model="model"
                    class="pl-4 pr-4 pb-4 pt-0"
                    center-active
                    show-arrows
                  >
                    <v-slide-item
                      v-for="(itemAudio, i) in filesDescargadasAudios"
                      :key="i"
                      v-slot="{ toggle }"
                    >
                      <v-card
                        class="ma-4"
                        height="auto"
                        width="auto"
                        tile
                        flat
                        @click="toggle"
                      >
                        <v-row class="" justify="center" align="center">
                          <audio controls>
                            <source :src="itemAudio.url" type="audio/mpeg" />
                            Your browser does not support the audio element.
                          </audio>
                        </v-row>
                      </v-card>
                    </v-slide-item>
                  </v-slide-group>
                </v-sheet>
              </v-col>
              <v-col cols="12" v-if="filesPDF.length > 0">
                <v-sheet elevation="8">
                  <div>
                    <v-btn
                      class="ml-4 mt-4"
                      outlined
                      rounded
                      color="blue"
                      @click="descargarPDF()"
                      v-if="mostrarBotonDescargar"
                      >Descargar archivos pdf</v-btn
                    >
                  </div>
                  <v-slide-group
                    v-model="model"
                    class="pa-4"
                    active-class="primary"
                    center-active
                    show-arrows
                  >
                    <v-slide-item
                      v-for="(item, i) in filesPDF"
                      :key="i"
                      v-slot="{ toggle }"
                    >
                      <v-card
                        class="ma-4"
                        height="200"
                        width="150"
                        @click="toggle"
                      >
                        <v-row class="fill-height" justify="center">
                          <v-scale-transition>
                            <v-img
                              :src="require('@/assets/logo_pdf.png')"
                            ></v-img>
                          </v-scale-transition>
                        </v-row>
                      </v-card>
                    </v-slide-item>
                  </v-slide-group>
                </v-sheet>
              </v-col>
            </v-row>
          </v-card>
        </v-container>
        <!-- Contenedor para encuesta de servicio -->
        <v-container class="mt-1">
          <v-card
            outlined
            width="100%"
            class="pa-2 mb-1"
            elevation="1"
            style="border: 1px solid black"
          >
            <v-card-title class="pa-0">Encuesta de servicio</v-card-title>
            <v-row justify="start" align="start">
              <v-col cols="12" md="4" class="pt-0">
                <v-card max-width="500" flat>
                  <v-card-title class="pb-0"
                    >Fue resuelta su necesidad</v-card-title
                  >
                  <v-checkbox
                    v-model="checkResueltaNecesidad"
                    :label="`Respuesta es: ${checkResueltaNecesidad}`"
                    class="ml-4"
                    hide-details
                  ></v-checkbox>
                  <v-btn
                    small
                    outlined
                    class="mt-2 ml-3"
                    @click="limpiarResuletaNecesidad()"
                    >Eliminar seleccion</v-btn
                  >
                  <v-card max-width="500" flat>
                    <v-card-title
                      class="pb-0"
                      style="white-space: no-wrap; word-break: keep-all"
                    >
                      ¿Contesto Llamada?</v-card-title
                    >
                    <v-checkbox
                      v-model="checkNoResponde"
                      label="No responde"
                      class="ml-4 py-0"
                      hide-details
                    ></v-checkbox>
                  </v-card>
                </v-card>
              </v-col>
              <v-col cols="12" md="4" class="pt-0">
                <v-card max-width="500" flat>
                  <v-card-title class="pb-0"
                    >Como califica nuestro servicio</v-card-title
                  >
                  <v-radio-group
                    v-model="radioGroupCalificaServicio"
                    hide-details
                  >
                    <v-radio
                      label="Bueno"
                      value="BUENO"
                      color="green"
                      class="ml-4"
                    ></v-radio>
                    <v-radio
                      label="Malo"
                      value="MALO"
                      color="red"
                      class="ml-4"
                    ></v-radio>
                    <v-radio
                      label="Excelente"
                      value="EXCELENTE"
                      color="primary"
                      class="ml-4"
                    ></v-radio>
                  </v-radio-group>
                  <v-btn
                    small
                    outlined
                    class="mt-2 ml-3"
                    @click="limpiarCalificaServicio()"
                    >Eliminar seleccion</v-btn
                  >
                </v-card>
              </v-col>
              <v-col cols="12" md="4" class="pt-0">
                <v-card width="400" flat>
                  <v-card-title class="pb-0"
                    >Quejas u observaciones</v-card-title
                  >
                  <v-textarea
                    v-model="textAreaQuejaObservaciones"
                    outlined
                    auto-grow
                    hide-details
                    class="ml-4 pt-0 mt-0"
                  ></v-textarea>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-container>

        <div class="text-center">
          <v-dialog v-model="dialogVerImagen" width="500">
            <v-card>
              <v-card-text class="pt-5">
                <v-img :src="imagenDialog"></v-img>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="dialogVerImagen = false">
                  Cerrar
                </v-btn>
                <v-btn
                  color="error"
                  text
                  @click="dialogBorrarImagen = true"
                  v-if="banderaEliminar"
                >
                  Eliminar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
        <div class="text-center">
          <v-dialog v-model="dialogBorrarImagen" width="500">
            <v-card>
              <v-card-title class="headline grey lighten-2">
                Eliminar imagen
              </v-card-title>

              <v-card-text class="pt-5 title">
                ¿Está seguro de eliminar esta imagen?
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="dialogBorrarImagen = false">
                  No
                </v-btn>
                <v-btn color="primary" text @click="eliminarImagen()">
                  Si, seguro
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>

        <v-flex xs12 sm12 md12 lg12 xl12 class="mt-3">
          <v-btn @click="ocultarNuevo()" color="cancel" class="mr-1"
            >Cancelar</v-btn
          >
          <v-btn
            @click="actualizar()"
            color="success"
            v-if="verDet == 1"
            class="mx-1"
            >Actualizar</v-btn
          >
          <v-btn
            class="btn-hover color-4 mt-0 mb-0 ml-1 mr-1"
            @click="isShowing = true"
            v-if="verDet == 1"
          >
            BITACORA
          </v-btn>
          <v-btn @click="servicioAdicional()" color="info" class="mx-1"
            >Servicio Adicional</v-btn
          >
        </v-flex>
        <v-flex xs12 sm12 md12 lg12 xl12>
          <div
            class="red--text"
            v-for="v in validaMensaje"
            :key="v"
            v-text="v"
          ></div>
        </v-flex>
      </v-container>
      <v-btn
        v-scroll="onScroll"
        @click="toTop"
        v-show="fab"
        fab
        dark
        fixed
        bottom
        right
        color="error"
        v-if="verNuevo == 1"
        class="mb-10"
      >
        <i class="fas fa-chevron-up"></i>
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import settings from "../settings/index";
import { storage } from "../main";
import MiniBitacora from "./Minis/MiniBitacora.vue";

export default {
  components: {
    MiniBitacora,
  },
  data() {
    return {
      selectedUsuario: "TODOS",
      desbloqueoUsuariosLegales: [1035, 1063],
      horaConsultaAseguradora: null,
      horaConfirmacionAseguradora: null,
      btnConsulta: false,
      btnConfirmacion: false,
      cantRecuperoEncontrado: false,
      snackBarGlobal: false,
      snackBarGlobalText: "",
      checkNoResponde: null,
      creacionPendiente: false,
      vanGrupoId: null,
      vanGrupoEmpresa: null,
      DUIPersonaRecupero: null,
      personaRecupero: null,
      isShowing: false,
      usuariosCostoDesbloqueado: [1, 5, 8, 1079, 1032, 1051, 1115],
      usuariosCantRecDesbloqueado: [1007, 1032, 1035, 1011, 1051],

      costoCancelToken: null,
      costoEncontrado: false,
      tipoQueja: [],
      tipoInspeccionOnline: [],
      analistasSISAId: null,
      analistasSISA: [],
      tallerId: null,
      talleresSISA: [],
      observacionesCancelacion: [],
      selectedObsCanceclacion: null,
      descuentoId: null,
      descuentos: [],
      tipoQuejaId: null,
      tipoInspeccionId: null,
      relacionTitularId: null,
      relacionTitular: [],
      numeroTelefono2: "",
      numeroTelefono3: "",
      campoRequerido: [(v) => !!v || "Este campo es obligatorio"],
      legales: [],
      bitacoras: [],
      headers: [
        { text: "Opciones", align: "center", value: "action", sortable: false },
        {
          text: "Número Asistencia",
          value: "numeroAsistencia",
          align: "left",
        },
        {
          text: "Expediente",
          value: "expediente",
          align: "left",
        },
        {
          text: "Cartera",
          value: "cartera",
          align: "left",
        },
        {
          text: "Estatus",
          align: "left",
          value: "estatusAsistencia",
        },
        {
          text: "Fecha Actual",
          value: "fechaHoraActual",
          align: "left",
        },
        {
          text: "Proveedor",
          value: "proveedor",
          align: "left",
        },
        {
          text: "Tipo Asistencia",
          value: "tipoAsistencia",
          align: "left",
        },
        { text: "Numero Telefono", value: "numeroTelefono" },
        { text: "Placa", value: "placa", align: "left" },
        { text: "Poliza", value: "poliza", align: "left" },
        { text: "Marca", value: "marca", align: "left" },
        { text: "Modelo", value: "modelo", align: "left" },
        { text: "Año", value: "año", align: "left" },
        {
          text: "Titular Poliza",
          value: "titularPoliza",
          align: "left",
        },
        { text: "Operador", value: "operador", align: "left" },
      ],
      valid: true,
      campoRequerido: [(v) => !!v || "Este campo es obligatorio"],
      search: "",
      id: "",
      idBase: "",
      cartera: "",
      numeroAsistencia: "",
      list_cartera: [],
      fechaHoraOcurrencia: "",
      fechaHoraActualNuevo: "",
      numeroTelefono: "",
      placa: "",
      polizaBase: "",
      marcaBase: "",
      modeloBase: "",
      añoBase: 0,
      usoBase: "",
      titularPolizaBase: "",
      estatusBase: "",
      color: "",
      nombreConductor: "",
      pais: "",
      list_pais: settings.list_pais,
      depaSiniestro: "",
      list_depaSiniestro: settings.list_depaSiniestro,
      muniSiniestro: "",
      list_muniSiniestro: settings.list_muniSiniestro,
      comDireccionSiniestro: "",
      causa: "",
      list_causa: settings.list_causa,
      tipoServicio: "",
      list_tipoServicio: settings.list_tipoServicio,
      proveedor: "",
      list_proveedor: [],
      nombreProveedor: "",
      telefonoProveedor: "",
      fechaHoraAsignacion: "",
      depaOrigen: "",
      list_depaOrigen: settings.list_depaOrigen,
      muniOrigen: "",
      list_muniOrigen: settings.list_muniOrigen,
      comDireccionOrigen: "",
      depaDestino: "",
      list_depaDestino: settings.list_depaDestino,
      muniDestino: "",
      list_muniDestino: settings.list_muniDestino,
      comDireccionDestino: "",
      fechaHoraContacto: "",
      costoServicio: 0,
      costoSinDescuento: 0,
      totalDescuento: 0,
      fechaHoraCierreAsistencia: "",
      placaContraparte: "",
      partePolicial: false,
      expediente: null,
      obsAdicionales: "",
      tipoAsistencia: "",
      list_tipoAsistencia: [],
      quienSolicita: "",
      fechaSolicitudAjuste: "",
      seMovioDelLugar: false,
      zonaPeligrosa: false,
      reporteTardio: false,
      roboRecuperado: false,
      localForaneo: "",
      fueraTurno: false,
      kmCosto: 0,
      list_localForaneo: settings.list_localForaneo,
      responsable: "",
      operador: "",
      estatusAsistencia: "EN PROCESO",
      list_estatusAsistencia: [],
      verNuevo: 0,
      errorPlaca: null,
      valida: 0,
      validaMensaje: [],
      verDet: 0,
      fab: false,
      colorSiniestro: "",
      colorOrigen: "",
      colorDestino: "",
      cantRecupero: "",
      overlay: true,
      snackFechas: false,
      snackError: false,
      btnContacto: false,
      btnFinalizado: false,
      btnCierreFinalizado: false,
      termino: "",
      estadoEbriedad: false,
      protocolo: false,
      pasaFiscalia: false,
      costoValid: false,
      dateToday: "",
      fechaDesde: null,
      fechaHasta: null,
      textFieldContactoDisabled: true,
      textFieldTerminoDisabled: true,
      textFieldCierreDisabled: true,
      numeroCheque: "",
      cabinistaContacto: "",
      cabinistaTermino: "",
      cabinistaCierre: "",
      fechaHoraProgramado: "",
      reembolso: "",
      radioGroupRecobroConciliacion: null,
      pretencionInicial: "",
      pretencionFinal: "",
      agente: "",
      metodoSolicitudAsistencia: "LLAMADA",
      list_metodoSolicitud: settings.list_metodoSolicitud,
      checkboxRapiAssaSegunPlataforma: false,
      //variables para almacenamiento de imagenes
      filesCargadas: [],
      filesDescargadas: [],
      imagenesPreview: [],
      filesDescargadasAudios: [],
      filesPDF: [],
      disabledCargarArchivos: true,
      disabledDescargarArchivos: true,
      numeroAsistenciaCargar: "",
      numeroAsistenciaDescargar: "",
      nombreImagen: "",
      model: null,
      listaArchivos: [],
      dialogVerImagen: false,
      dialogBorrarImagen: false,
      imagenDialog: "",
      banderaEliminar: false,
      bandera: 0,
      snackArchivoSubido: false,
      snackArchivoEliminado: false,
      overlayArchivos: false,
      tipoDatoArchivo: "",
      mostrarBotonDescargar: false,
      reembolso: false,
      //variables para encuesta de servicio
      checkResueltaNecesidad: null,
      radioGroupCalificaServicio: "SD",
      textAreaQuejaObservaciones: "",
      llenoFormularioReclamo: "",
      //variables de datos del ajustador para Assa
      expedienteAssa: "",
      inspeccionInSituVirtual: "",
      rapiAssaAsegurado: "",
      rapiAssaTercero: "",
      motivoNoUsoRapiassa: "",
      motivoNoUsoRapiassaTercero: "",
      motivoDeNoUsoTaller: "",
      usoGruaAsegurado: "",
      usoGruaTercero: "",
      tallerAsegurado: "",
      tallerTercero: "",
      estadoVirtual: "",
      list_inspeccionInSituVirtual: settings.list_inspeccionInSituVirtual,
      list_rapiAssaAsegurado: settings.list_rapiAssaAsegurado,
      list_rapiAssaTercero: settings.list_rapiAssaTercero,
      list_usoGruaAsegurado: settings.list_usoGruaAsegurado,
      list_estadoVirtual: settings.list_estadoVirtual,
      list_redTalleres: settings.list_redTalleres,
      list_motivoNoUsoRapiassa: settings.list_motivoNoUsoRapiassa,
      list_motivoDeNoTaller: settings.list_motivoDeNoTaller,
      itemsDeclinaciones: [
        "ESTADO DE EBRIEDAD",
        "CAMBIO DE CONDUCTOR",
        "FRAUDE",
      ],
      declinaciones: "",
      ahorroDe: "",
      //url_open_win: "http://localhost:8080/adminArchivos/",
      url_open_win: "https://asistenciaregional.com/adminArchivos/",
    };
  },
  created() {
    this.listarTipoAsistencias();
    this.listarCarteras();
    this.listarComboBox();
    this.listar();
    this.getProveedores();
  },
  watch: {
    proveedor(val) {
      if (!val) {
        this.fechaHoraAsignacion = null;
      }
    },
    tipoAsistencia(val) {
      if (val && val != "QUEJA") {
        this.tipoQuejaId = null;
      }

      if (val && val != "INSPECCION ON LINE") {
        this.tipoInspeccionId = null;
      }
    },
    localForaneo(val) {
      if (val != "FORANEO") {
        this.kmCosto = 0;
      }
    },
  },
  computed: {
    legalesFiltered() {
      if (this.selectedUsuario == "TODOS") return this.legales;
      return this.legales.filter(
        (l) => l.usuarioBitacora == this.selectedUsuario
      );
    },
    usuariosBitacoraLegal() {
      if (this.legales.length > 0) {
        return [
          "TODOS",
          ...new Set(
            this.legales
              .filter(
                (c) => c.usuarioBitacora != null && c.usuarioBitacora !== ""
              )
              .map((c) => c.usuarioBitacora)
          ),
        ];
      }

      return ["TODOS"];
    },
    talleresCartera() {
      if (this.cartera == "SISA SEGUROS") {
        return [
          "CENTRO DE ESTIMACION",
          "TALLER PARTICULAR",
          "PAGO EXPRESS",
          "VALUO VIDEO LLAMADA",
          "REPARACION POR SER ASEGURADO CON SISA",
        ];
      }
      return this.list_redTalleres;
    },
    showBitacoraLegal() {
      return this.tipoAsistencia == "LEGAL" && !this.desbloquearLegales;
    },
    getPorcentajeDescuento() {
      const descuento = this.descuentos.filter(
        (d) => d.descuentoId == this.descuentoId
      );

      if (descuento.length > 0) {
        return `${descuento[0].porcentaje * 100}%`;
      }

      return "0%";
    },
    formTitle() {
      return "Seguimiento";
    },
    desbloquearCostoServicio() {
      return this.usuariosCostoDesbloqueado.some(
        (id) => this.$store.state.usuario.idUsuario == id
      );
    },
    desbloquearLegales() {
      return this.desbloqueoUsuariosLegales.some(
        (id) => this.$store.state.usuario.idUsuario == id
      );
    },
    desbloquearCantRecobro() {
      return this.usuariosCantRecDesbloqueado.some(
        (id) => this.$store.state.usuario.idUsuario == id
      );
    },
    getPorcentajeRecupero() {
      return (this.cantRecupero * 0.05).toFixed(2);
    },
  },
  methods: {
    autoCompConsultaAseguradora() {
      var today = new Date();
      const hora =
        new Date().getHours() +
        ":" +
        new Date().getMinutes() +
        ":" +
        new Date().getSeconds();
      this.horaConsultaAseguradora =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate() +
        " " +
        hora;
      this.btnConsulta = true;
    },
    autoCompConfirmacionAseguradora() {
      var today = new Date();
      const hora =
        new Date().getHours() +
        ":" +
        new Date().getMinutes() +
        ":" +
        new Date().getSeconds();
      this.horaConfirmacionAseguradora =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate() +
        " " +
        hora;
      this.btnConfirmacion = true;
    },
    servicioAdicional() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;
      if (this.creacionPendiente) return;
      this.creacionPendiente = true;

      var today = new Date();
      me.fechaHoraActualNuevo =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate() +
        " " +
        new Date().getHours() +
        ":" +
        new Date().getMinutes() +
        ":" +
        new Date().getSeconds();
      axios
        .post(
          "api/Cabinas/Crear",
          {
            idCabina: me.id,
            idBase: me.idBase,
            idUsuario: me.$store.state.usuario.idUsuario,
            idProveedor: me.proveedor,
            cartera: me.cartera,
            fechaHoraActual: me.fechaHoraActualNuevo,
            fechaHoraOcurrencia: me.fechaHoraOcurrencia,
            numeroTelefono: me.numeroTelefono,
            placa: me.placa,
            poliza: me.polizaBase,
            marca: me.marcaBase,
            modelo: me.modeloBase,
            año: me.añoBase,
            uso: me.usoBase,
            color: me.color,
            nombreConductor: me.nombreConductor,
            titularPoliza: me.titularPolizaBase,
            pais: me.pais,
            depaSiniestro: me.depaSiniestro,
            muniSiniestro: me.muniSiniestro,
            comDireccionSiniestro: me.comDireccionSiniestro,
            causa: me.causa,
            tipoServicio: me.tipoServicio,
            proveedor: me.nombreProveedor,
            telefonoProveedor: me.telefonoProveedor,
            fechaHoraAsignacion: me.fechaHoraAsignacion,
            depaOrigen: me.depaOrigen,
            muniOrigen: me.muniOrigen,
            comDireccionOrigen: me.comDireccionOrigen,
            depaDestino: me.depaDestino,
            muniDestino: me.muniDestino,
            comDireccionDestino: me.comDireccionDestino,
            fechaHoraContacto: me.fechaHoraContacto,
            costoServicio: 0,
            fechaHoraCierreAsistencia: me.fechaHoraCierreAsistencia,
            placaContraparte: me.placaContraparte,
            partePolicial: me.partePolicial,
            obsAdicionales: me.obsAdicionales,
            tipoAsistencia: me.tipoAsistencia,
            quienSolicita: me.quienSolicita,
            fechaSolicitudAjuste: me.fechaSolicitudAjuste,
            seMovioDelLugar: me.seMovioDelLugar,
            zonaPeligrosa: me.zonaPeligrosa,
            reporteTardio: me.reporteTardio,
            operador: me.operador,
            estatusAsistencia: me.estatusAsistencia,
            roboRecuperado: me.roboRecuperado,
            localForaneo: me.localForaneo,
            cantRecupero: null,
            termino: me.termino,
            estadoEbriedad: me.estadoEbriedad,
            numeroCheque: me.numeroCheque,
            cabinistaContacto: me.cabinistaContacto,
            cabinistaTermino: me.cabinistaTermino,
            cabinistaCierre: me.cabinistaCierre,
            protocolo: me.protocolo,
            pasaFiscalia: me.pasaFiscalia,
            responsable: me.responsable,
            preguntaCalificaServicio: me.radioGroupCalificaServicio,
            preguntaQuejaObservaciones: me.textAreaQuejaObservaciones,
            fechaHoraProgramado: me.fechaHoraProgramado,
            metodoSolicitudAsistencia: me.metodoSolicitudAsistencia,
            reembolso: me.reembolso,
            expedienteAssa: me.expedienteAssa,
            inspeccionInSituVirtual: me.inspeccionInSituVirtual,
            rapiAssaAsegurado: me.rapiAssaAsegurado,
            rapiAssaTercero: me.rapiAssaTercero,
            motivoNoUsoRapiassa: me.motivoNoUsoRapiassa,
            motivoNoUsoRapiassaTercero: me.motivoNoUsoRapiassaTercero,
            usoGruaAsegurado: me.usoGruaAsegurado,
            usoGruaTercero: me.usoGruaTercero,
            tallerTercero: me.tallerTercero,
            tallerAsegurado: me.tallerAsegurado,
            estadoVirtual: me.estadoVirtual,
            agente: me.agente,
            checkboxRapiAssaSegunPlataforma: me.checkboxRapiAssaSegunPlataforma,
            motivoDeNoTaller: me.motivoDeNoUsoTaller,
            nombreRecupero: null,
            pretencionInicial: me.pretencionInicial,
            pretencionFinal: me.pretencionFinal,
            declinaciones: me.declinaciones,
            ahorroDe: me.ahorroDe,
            preguntaLlenoFormularioReclamo: me.llenoFormularioReclamo,
            relacionTitularId: this.relacionTitularId,
            tipoQuejaId: this.tipoQuejaId,
            tipoInspeccionId: this.tipoInspeccionId,
            numeroTelefono2: this.numeroTelefono2,
            numeroTelefono3: this.numeroTelefono3,
            fueraTurno: this.fueraTurno,
            kmCosto: this.kmCosto,
            bitacoras: this.bitacoras,
            expediente: this.expediente,
            vanGrupoID: me.cartera == "VANGRUPO" ? me.vanGrupoId : null,
            vanGrupoEmpresa:
              this.cartera == "VANGRUPO" ? this.vanGrupoEmpresa : null,
            dui: this.DUIPersonaRecupero,
            personaRecupero: this.personaRecupero,
          },
          configuracion
        )
        .then(function (response) {
          me.ocultarNuevo();
          me.listar();
          me.limpiar();
        })
        .catch(function (error) {
          console.log(error);
          me.snackError = true;
        })
        .finally(() => (this.creacionPendiente = false));
      this.bitacoras = [];
    },
    listarTipoAsistencias() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get("api/TipoAsistencias/Activas", configuracion)
        .then((res) => (this.list_tipoAsistencia = res.data))
        .catch((err) => console.error(err.response));
    },
    listarCarteras() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get("api/Carteras/Activas", configuracion)
        .then((res) => (this.list_cartera = res.data))
        .catch((err) => console.error(err.response));
    },
    calcularCosto() {
      if (
        this.estatusAsistencia == "EN PROCESO" ||
        this.estatusAsistencia == "EN TRAMITE" ||
        this.estatusAsistencia == "SERVICIO MUERTO/BANDERAZO" ||
        this.estatusAsistencia == "FINALIZADO"
      ) {
        this.costoEncontrado = false;

        let header = { Authorization: "Bearer " + this.$store.state.token };

        axios
          .post(
            "api/CostosProveedores/GetCosto",
            {
              numeroAsistencia: this.numeroAsistencia,
              proveedorId: this.proveedor,
              tipoAsistencia: this.tipoAsistencia,
              fueraTurno: this.fueraTurno,
              localidad: this.localForaneo,
              expediente: this.expediente,
              kmCosto: this.kmCosto,
              cartera: this.cartera,
              estatusAsistencia: this.estatusAsistencia,
              descuentoId: this.descuentoId,
              recupero: this.cantRecupero,
              nombreRecupero: this.radioGroupRecobroConciliacion,
            },
            {
              headers: header,
              cancelToken: this.costoCancelToken
                ? this.costoCancelToken.token
                : null,
            }
          )
          .then((res) => {
            const detalleCostos = res.data;
            this.costoServicio = detalleCostos.costo.toFixed(2);
            this.costoSinDescuento = detalleCostos.costoSinDescuento.toFixed(2);
            this.totalDescuento = detalleCostos.totalDescuento.toFixed(2);

            this.costoEncontrado = this.costoServicio > 0 ? true : false;
          })
          .catch((err) => {
            if (axios.isCancel(err)) {
              console.warn(err.message);
            } else {
              this.costoEncontrado = false;
              console.error(err);
            }
            this.costoServicio = 0;
          });
      }
    },
    listarComboBox() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get("api/Cabinas/RelacionTitular", configuracion)
        .then((res) => {
          this.relacionTitular = res.data;
        })
        .catch((err) => console.error(err));

      axios
        .get("api/TallerSisa", configuracion)
        .then((res) => {
          this.talleresSISA = res.data;
        })
        .catch((err) => {
          console.log(err);
        });

      axios
        .get("api/ObservacionesCancelacion", configuracion)
        .then((res) => {
          this.observacionesCancelacion = res.data;
        })
        .catch((err) => console.error(err));

      axios
        .get("api/EstadosAsistencia", configuracion)
        .then((res) => {
          const isAdminProveedores =
            this.$store.state.usuario.rol == "Admin Proveedores";
          if (isAdminProveedores) {
            this.list_estatusAsistencia = res.data;
          } else {
            const estadosLegales = [
              "EN TRAMITE",
              "CANCELADO",
              "FINALIZADO",
              "CANCELADO A SOLICITUD",
            ];
            this.list_estatusAsistencia = res.data.filter((estado) =>
              estadosLegales.includes(estado.estado)
            );
          }
        })
        .catch((err) => console.error(err));

      axios
        .get("api/TipoQuejas", configuracion)
        .then((res) => (this.tipoQueja = res.data))
        .catch((err) => console.error(err));

      axios
        .get("api/Descuento", configuracion)
        .then((res) => (this.descuentos = res.data))
        .catch((err) => console.error(err));

      axios
        .get("api/Analistas", configuracion)
        .then((res) => (this.analistasSISA = res.data))
        .catch((err) => console.error(err));

      axios
        .get("api/ConfiguracionesGenerales/UsuariosCostos", configuracion)
        .then((res) => (this.usuariosCostoDesbloqueado = res.data.split(",")))
        .catch((err) => console.error(err));

      axios
        .get("api/ConfiguracionesGenerales/UsuariosCantRecupero", configuracion)
        .then((res) => {
          this.usuariosCantRecDesbloqueado = res.data.split(",");
        })
        .catch((err) => console.error(err));

      axios
        .get("api/ConfiguracionesGenerales/UsuariosLegales", configuracion)
        .then((res) => {
          this.desbloqueoUsuariosLegales = res.data.split(",");
        })
        .catch((err) => console.error(err));
    },
    async oneDrive(item) {
      window.open(this.url_open_win + item.numeroAsistencia, "_blank");
    },
    limpiarCalificaServicio() {
      this.radioGroupCalificaServicio = null;
    },
    limpiarResuletaNecesidad() {
      this.checkResueltaNecesidad = null;
    },
    getProveedores() {
      const listaProveedores = [];
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/DetallexProveedores/Listar", configuracion)
        .then(function (response) {
          const list_proveedores = response.data;
          for (var i = 0; i < list_proveedores.length; i++) {
            if (list_proveedores[i].estado) {
              me.list_proveedor.push({
                idProveedor: list_proveedores[i].idProveedor,
                nombre: list_proveedores[i].nombre,
              });
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
      return listaProveedores;
    },
    ocultarNuevo() {
      this.verNuevo = 0;
      this.limpiar();
    },
    listar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      me.overlay = true;
      axios
        .get("api/Cabinas/Legales/Seguimientos", configuracion)
        .then(function (response) {
          me.legales = [];
          me.legales = response.data;
          me.overlay = false;
        })
        .catch(function (error) {
          console.log("ERROR ", error);
          me.overlay = false;
        });
    },
    verDetalles(item) {
      this.limpiar();
      this.relacionTitularId = item.relacionTitularId;
      this.tipoQuejaId = item.tipoQuejaId;
      this.tipoInspeccionId = item.tipoInspeccionId;
      this.numeroTelefono2 = item.numeroTelefono2;
      this.numeroTelefono3 = item.numeroTelefono3;
      this.id = item.idCabina;
      this.idBase = item.idBase;
      this.idUsuario = item.idUsuario;
      this.proveedor = item.idProveedor;
      this.fechaHoraActual = item.fechaHoraActual;
      this.numeroAsistencia = item.numeroAsistencia;
      this.cartera = item.cartera;
      this.fechaHoraOcurrencia = item.fechaHoraOcurrencia;
      this.numeroTelefono = item.numeroTelefono;
      this.placa = item.placa;
      this.polizaBase = item.poliza;
      this.marcaBase = item.marca;
      this.modeloBase = item.modelo;
      this.añoBase = item.año;
      this.usoBase = item.uso;
      this.titularPolizaBase = item.titularPoliza;
      this.color = item.color;
      this.nombreConductor = item.nombreConductor;
      this.pais = item.pais;
      this.depaSiniestro = item.depaSiniestro;
      this.list_muniSiniestro[0] = item.muniSiniestro;
      this.muniSiniestro = this.list_muniSiniestro[0];
      this.comDireccionSiniestro = item.comDireccionSiniestro;
      this.causa = item.causa;
      this.tipoServicio = item.tipoServicio;
      this.nombreProveedor = item.proveedor;
      this.fueraTurno = !!item.fueraTurno;
      this.telefonoProveedor = item.telefonoProveedor;
      this.fechaHoraAsignacion = item.fechaHoraAsignacion;
      this.depaOrigen = item.depaOrigen;
      this.list_muniOrigen[0] = item.muniOrigen;
      this.muniOrigen = this.list_muniOrigen[0];
      this.comDireccionOrigen = item.comDireccionOrigen;
      this.depaDestino = item.depaDestino;
      this.list_muniDestino[0] = item.muniDestino;
      this.muniDestino = this.list_muniDestino[0];
      this.comDireccionDestino = item.comDireccionDestino;
      this.fechaHoraContacto = item.fechaHoraContacto;
      this.costoServicio = item.costoServicio;

      this.cantRecuperoEncontrado = !!item.cantRecupero;

      this.kmCosto = !item.kmCosto ? 0 : item.kmCosto;
      this.fechaHoraCierreAsistencia = item.fechaHoraCierreAsistencia;
      this.placaContraparte = item.placaContraparte;
      this.partePolicial = item.partePolicial;
      this.obsAdicionales = item.obsAdicionales;
      this.tipoAsistencia = item.tipoAsistencia;
      this.operador = item.operador;
      this.quienSolicita = item.quienSolicita;
      this.fechaSolicitudAjuste = item.fechaSolicitudAjuste;
      this.seMovioDelLugar = item.seMovioDelLugar;
      this.zonaPeligrosa = item.zonaPeligrosa;
      this.reporteTardio = item.reporteTardio;
      this.estatusAsistencia = item.estatusAsistencia;
      this.roboRecuperado = item.roboRecuperado;
      this.localForaneo = item.localForaneo;
      this.radioGroupRecobroConciliacion = item.nombreRecupero;
      this.cantRecupero = item.cantRecupero;
      this.termino = item.termino;
      this.estadoEbriedad = item.estadoEbriedad;
      this.numeroCheque = item.numeroCheque;
      this.cabinistaContacto = item.cabinistaContacto;
      this.cabinistaTermino = item.cabinistaTermino;
      this.cabinistaCierre = item.cabinistaCierre;
      this.protocolo = item.protocolo;
      this.pasaFiscalia = item.pasaFiscalia;
      this.responsable = item.responsable;
      this.fechaHoraProgramado = item.fechaHoraProgramado;
      this.reembolso = item.reembolso;
      this.metodoSolicitudAsistencia = item.metodoSolicitudAsistencia;
      this.checkboxRapiAssaSegunPlataforma =
        item.checkboxRapiAssaSegunPlataforma;
      this.pretencionInicial = item.pretencionInicial;
      this.pretencionFinal = item.pretencionFinal;
      this.declinaciones = item.declinaciones;
      this.ahorroDe = item.ahorroDe;
      this.llenoFormularioReclamo = item.preguntaLlenoFormularioReclamo;
      this.agente = item.agente;
      //variables de ajustadores para ASSA
      this.expedienteAssa = item.expedienteAssa;
      this.inspeccionInSituVirtual = item.inspeccionInSituVirtual;
      this.rapiAssaAsegurado = item.rapiAssaAsegurado;
      this.rapiAssaTercero = item.rapiAssaTercero;
      this.motivoNoUsoRapiassa = item.motivoNoUsoRapiassa;
      this.motivoNoUsoRapiassaTercero = item.motivoNoUsoRapiassaTercero;
      this.motivoDeNoUsoTaller = item.motivoDeNoTaller;
      this.usoGruaAsegurado = item.usoGruaAsegurado;
      this.usoGruaTercero = item.usoGruaTercero;
      this.tallerAsegurado = item.tallerAsegurado;
      this.tallerTercero = item.tallerTercero;
      this.estadoVirtual = item.estadoVirtual;
      this.vanGrupoId = item.vanGrupoID;
      this.vanGrupoEmpresa = item.vanGrupoEmpresa;
      this.DUIPersonaRecupero = item.dui;
      this.personaRecupero = item.personaRecupero;
      this.costoSinDescuento = !!item.costoSinDescuento
        ? item.costoSinDescuento
        : "0.00";
      this.totalDescuento = !!item.totalDescuento
        ? item.totalDescuento
        : "0.00";
      this.descuentoId = item.descuentoId;
      this.analistasSISAId = item.analistaId;
      this.tallerId = item.tallerId;
      this.selectedObsCanceclacion = item.observacionCancelacion;
      this.comentarioAutoriza = item.comentarioAutoriza;
      this.verNuevo = 1;
      this.verDet = 1;
      this.expediente = item.expediente;

      this.verificarAsignacion();
      this.verificarFechaContacto();
      this.verificarFinalizado();
      this.verificarCierreFinalizado();
      if (
        this.$store.state.usuario.nombre != "IVAN GRACIAS" &&
        this.$store.state.usuario.nombre != "BRENDA HERNANDEZ" &&
        this.$store.state.usuario.nombre != "JOSE ATILIO HERNANDEZ" &&
        this.$store.state.usuario.nombre != "Andrea Margarita Zaldivar Campos"
      ) {
        this.verificaCostoServicio();
      }
      this.radioGroupCalificaServicio = item.preguntaCalificaServicio;
      this.textAreaQuejaObservaciones = item.preguntaQuejaObservaciones;
      if (item.preguntaResueltaNecesidad == "SI") {
        this.checkResueltaNecesidad = true;
      } else if (item.preguntaResueltaNecesidad == "NO") {
        this.checkResueltaNecesidad = false;
      } else {
        this.checkResueltaNecesidad = null;
      }

      if (item.preguntaNoRespondeLlamada == "SI") {
        this.checkNoResponde = true;
      } else if (item.preguntaNoRespondeLlamada == "NO") {
        this.checkNoResponde = false;
      } else {
        this.checkNoResponde = null;
      }

      this.getDetallesAsistencia();
    },
    getDetallesAsistencia() {
      if (!this.id) return;

      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get(`api/DetallesCabina/${this.numeroAsistencia}`, configuracion)
        .then((res) => {
          this.horaConfirmacionAseguradora = res.data.horaConfirmadoAseguradora;
          this.horaConsultaAseguradora = res.data.horaConsultaAseguradora;

          if (this.horaConsultaAseguradora) {
            this.btnConsulta = true;
          }
          if (this.horaConfirmacionAseguradora) {
            this.btnConfirmacion = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    updateDetallesCabina() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .put(
          `api/DetallesCabina/${this.numeroAsistencia}`,
          {
            horaConsultaAseguradora: this.horaConsultaAseguradora,
            horaConfirmacionAseguradora: this.horaConfirmacionAseguradora,
          },
          configuracion
        )
        .then((res) => {})
        .catch((err) => {
          console.log(err);
        });
    },
    actualizar() {
      try {
        this.updateDetallesCabina();
      } catch (error) {}
      if (this.estatusAsistencia == "CANCELADO A SOLICITUD") {
        if (!this.$refs.fObsCancelacion.validate()) {
          this.snackBarGlobalText =
            "Debe Seleccionar una Observación de Cancelación";
          this.snackBarGlobal = true;
          return;
        }
      } else {
        if (this.validar()) {
          return;
        }
      }

      if (
        this.cartera == "FUTURO ASISTENCIA" &&
        this.quienSolicita &&
        !this.comentarioAutoriza
      ) {
        if (!this.$refs.fComentarioAutoriza.validate()) {
          this.snackBarGlobalText =
            "Debe Colocar un Comentario de Autorización!";
          this.snackBarGlobal = true;

          return;
        }
      }

      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;
      if (me.checkResueltaNecesidad) {
        var checkBoxConvertir = "SI";
      } else if (me.checkResueltaNecesidad == false) {
        var checkBoxConvertir = "NO";
      }

      let noRespondeLlamada = null;
      if (this.checkNoResponde) {
        noRespondeLlamada = "SI";
      } else if (me.checkNoResponde == false) {
        noRespondeLlamada = "NO";
      }

      if (this.creacionPendiente) return;
      this.creacionPendiente = true;

      axios
        .put(
          "api/Cabinas/Actualizar",
          {
            idCabina: me.id,
            idBase: me.idBase,
            idUsuario: me.$store.state.usuario.idUsuario,
            idProveedor: me.proveedor,
            cartera: me.cartera,
            fechaHoraOcurrencia: me.fechaHoraOcurrencia,
            numeroTelefono: me.numeroTelefono,
            placa: me.placa,
            poliza: me.polizaBase,
            marca: me.marcaBase,
            modelo: me.modeloBase,
            año: me.añoBase,
            uso: me.usoBase,
            color: me.color,
            nombreConductor: me.nombreConductor,
            titularPoliza: me.titularPolizaBase,
            pais: me.pais,
            depaSiniestro: me.depaSiniestro,
            muniSiniestro: me.muniSiniestro,
            comDireccionSiniestro: me.comDireccionSiniestro,
            causa: me.causa,
            tipoServicio: me.tipoServicio,
            proveedor: me.nombreProveedor,
            telefonoProveedor: me.telefonoProveedor,
            fechaHoraAsignacion: me.fechaHoraAsignacion,
            depaOrigen: me.depaOrigen,
            muniOrigen: me.muniOrigen,
            comDireccionOrigen: me.comDireccionOrigen,
            depaDestino: me.depaDestino,
            muniDestino: me.muniDestino,
            comDireccionDestino: me.comDireccionDestino,
            fechaHoraContacto: me.fechaHoraContacto,
            costoServicio: me.costoServicio,
            fechaHoraCierreAsistencia: me.fechaHoraCierreAsistencia,
            placaContraparte: me.placaContraparte,
            partePolicial: me.partePolicial,
            obsAdicionales: me.obsAdicionales,
            tipoAsistencia: me.tipoAsistencia,
            quienSolicita: me.quienSolicita,
            fechaSolicitudAjuste: me.fechaSolicitudAjuste,
            seMovioDelLugar: me.seMovioDelLugar,
            zonaPeligrosa: me.zonaPeligrosa,
            reporteTardio: me.reporteTardio,
            operador: me.operador,
            estatusAsistencia: me.estatusAsistencia,
            roboRecuperado: me.roboRecuperado,
            localForaneo: me.localForaneo,
            cantRecupero: me.cantRecupero,
            termino: me.termino,
            estadoEbriedad: me.estadoEbriedad,
            numeroCheque: me.numeroCheque,
            cabinistaContacto: me.cabinistaContacto,
            cabinistaTermino: me.cabinistaTermino,
            cabinistaCierre: me.cabinistaCierre,
            protocolo: me.protocolo,
            pasaFiscalia: me.pasaFiscalia,
            responsable: me.responsable,
            preguntaNoRespondeLlamada: noRespondeLlamada,
            preguntaResueltaNecesidad: checkBoxConvertir,
            preguntaCalificaServicio: me.radioGroupCalificaServicio,
            preguntaQuejaObservaciones: me.textAreaQuejaObservaciones,
            fechaHoraProgramado: me.fechaHoraProgramado,
            metodoSolicitudAsistencia: me.metodoSolicitudAsistencia,
            reembolso: me.reembolso,
            expedienteAssa: me.expedienteAssa,
            inspeccionInSituVirtual: me.inspeccionInSituVirtual,
            rapiAssaAsegurado: me.rapiAssaAsegurado,
            rapiAssaTercero: me.rapiAssaTercero,
            motivoNoUsoRapiassa: me.motivoNoUsoRapiassa,
            motivoNoUsoRapiassaTercero: me.motivoNoUsoRapiassaTercero,
            usoGruaAsegurado: me.usoGruaAsegurado,
            usoGruaTercero: me.usoGruaTercero,
            tallerTercero: me.tallerTercero,
            tallerAsegurado: me.tallerAsegurado,
            estadoVirtual: me.estadoVirtual,
            agente: me.agente,
            checkboxRapiAssaSegunPlataforma: me.checkboxRapiAssaSegunPlataforma,
            motivoDeNoTaller: me.motivoDeNoUsoTaller,
            nombreRecupero: me.radioGroupRecobroConciliacion,
            pretencionInicial: me.pretencionInicial,
            pretencionFinal: me.pretencionFinal,
            declinaciones: me.declinaciones,
            ahorroDe: me.ahorroDe,
            preguntaLlenoFormularioReclamo: me.llenoFormularioReclamo,
            relacionTitularId: this.relacionTitularId,
            tipoQuejaId: this.tipoQuejaId,
            tipoInspeccionId: this.tipoInspeccionId,
            numeroTelefono2: this.numeroTelefono2,
            numeroTelefono3: this.numeroTelefono3,
            fueraTurno: this.fueraTurno,
            kmCosto: this.kmCosto,
            vanGrupoID: me.cartera == "VANGRUPO" ? me.vanGrupoId : null,
            vanGrupoEmpresa:
              this.cartera == "VANGRUPO" ? this.vanGrupoEmpresa : null,
            personaRecupero: this.personaRecupero,
            dui: this.DUIPersonaRecupero,
            descuentoId: this.descuentoId,
            totalDescuento: this.totalDescuento,
            costoSinDescuento: this.costoSinDescuento,
            analistaId: this.analistasSISAId,
            tallerId: this.tallerId,
            observacionCancelacion: this.selectedObsCanceclacion,
            comentarioAutoriza: this.comentarioAutoriza,
          },
          configuracion
        )
        .then(function (response) {
          me.ocultarNuevo();
          me.listar();
          me.limpiar();
        })
        .catch(function (error) {
          console.log(error);
          me.snackError = true;
        })
        .finally(() => {
          this.creacionPendiente = false;
        });
    },
    validar() {
      this.valida = 0;
      this.validaMensaje = [];

      if (
        this.estatusAsistencia != "EN TRAMITE" &&
        this.estatusAsistencia != "EN PROCESO"
      ) {
        if (
          !this.placa ||
          !this.polizaBase ||
          !this.marcaBase ||
          !this.modeloBase ||
          !this.añoBase ||
          !this.relacionTitularId ||
          !this.titularPolizaBase ||
          !this.cartera ||
          !this.fechaHoraOcurrencia ||
          !this.numeroTelefono ||
          !this.color ||
          !this.nombreConductor ||
          !this.pais ||
          !this.depaSiniestro ||
          !this.muniSiniestro ||
          !this.comDireccionSiniestro ||
          !this.causa ||
          !this.tipoAsistencia ||
          !this.proveedor ||
          !this.depaOrigen ||
          !this.muniOrigen ||
          !this.comDireccionOrigen ||
          !this.depaDestino ||
          !this.muniDestino ||
          !this.comDireccionDestino ||
          !this.fechaHoraContacto ||
          this.costoServicio == null ||
          !this.termino ||
          !this.fechaHoraCierreAsistencia ||
          !this.placaContraparte ||
          !this.obsAdicionales ||
          !this.tipoServicio ||
          !this.localForaneo
        ) {
          this.validaMensaje.push("LOS CAMPOS NO PUEDEN QUEDAR VACIOS");
          this.$refs.form.validate();
        }
      }
      if (this.validaMensaje.length) {
        this.valida = 1;
      }
      return this.valida;
    },
    limpiar() {
      this.checkNoResponde = null;
      this.id = "";
      this.idBase = "";
      this.idUsuario = "";
      this.idProveedor = 0;
      this.cartera = "";
      this.fechaHoraOcurrencia = "";
      this.numeroTelefono = "";
      this.placa = "";
      this.polizaBase = "";
      this.modeloBase = "";
      this.marcaBase = "";
      this.expediente = null;
      this.añoBase = 0;
      this.usoBase = "";
      this.titularPolizaBase = "";
      (this.condicion = ""), (this.color = "");
      this.nombreConductor = "";
      this.asegurado = "";
      this.pais = "";
      this.depaSiniestro = "";
      this.muniSiniestro = "";
      this.comDireccionSiniestro = "";
      this.causa = "";
      this.tipoServicio = "";
      this.proveedor = "";
      this.nombreProveedor = "";
      this.telefonoProveedor = "";
      this.fechaHoraAsignacion = "";
      this.depaOrigen = "";
      this.muniOrigen = "";
      this.vanGrupoId = null;
      this.vanGrupoEmpresa = null;
      this.DUIPersonaRecupero = null;
      this.personaRecupero = null;
      this.comDireccionOrigen = "";
      this.depaDestino = "";
      this.muniDestino = "";
      this.comDireccionDestino = "";
      this.fechaHoraContacto = "";
      this.costoServicio = "";
      this.fechaHoraCierreAsistencia = "";
      this.placaContraparte = "";
      this.partePolicial = false;
      this.obsAdicionales = "";
      this.tipoAsistencia = "";
      this.quienSolicita = "";
      this.fechaSolicitudAjuste = "";
      this.seMovioDelLugar = false;
      this.zonaPeligrosa = false;
      this.reporteTardio = false;
      this.roboRecuperado = false;
      (this.localForaneo = ""), (this.operador = "");
      this.estatusAsistencia = "EN PROCESO";
      this.cantRecupero = "";
      this.termino = "";
      this.estadoEbriedad = false;
      this.verDet = 0;
      this.bitacoras = [];
      this.validaMensaje = [];
      this.errorPlaca = null;
      this.colorSiniestro = "";
      this.colorOrigen = "";
      this.colorDestino = "";
      this.btnContacto = false;
      this.btnFinalizado = false;
      this.btnCierreFinalizado = false;
      this.costoValid = false;
      this.imagenesPreview = [];
      this.filesDescargadasAudios = [];
      this.numeroCheque = "";
      this.cabinistaContacto = "";
      this.cabinistaTermino = "";
      this.cabinistaCierre = "";
      this.protocolo = false;
      this.pasaFiscalia = false;
      this.responsable = "";
      this.checkResueltaNecesidad = null;
      this.radioGroupCalificaServicio = "";
      this.textAreaQuejaObservaciones = "";
      this.fechaHoraProgramado = "";
      this.reembolso = false;
      this.radioGroupRecobroConciliacion = null;
      this.pretencionInicial = "";
      this.pretencionFinal = "";
      this.metodoSolicitudAsistencia = "LLAMADA";
      this.relacionTitularId = null;
      this.tipoQuejaId = null;
      this.tipoInspeccionId = null;
      this.numeroTelefono2 = "";
      this.numeroTelefono3 = "";
      this.fueraTurno = false;
      this.kmCosto = 0;
      this.costoSinDescuento = null;
      this.totalDescuento = null;
      this.descuentoId = null;
      this.analistasSISAId = null;
      this.tallerId = null;
      this.comentarioAutoriza = null;
      this.selectedObsCanceclacion = null;

      this.horaConsultaAseguradora = null;
      this.horaConfirmacionAseguradora = null;
      this.btnConsulta = false;
      this.btnConfirmacion = false;
    },
    autoCompFechaAsignacion() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get(
          "api/DetallexProveedores/ListarId/" + this.proveedor,
          configuracion
        )
        .then(function (response) {
          me.nombreProveedor = response.data[0].nombre;
          me.telefonoProveedor = response.data[0].telefono;
        })
        .catch(function (error) {
          console.log(error);
        });

      var horaAsignacion =
        new Date().getHours() + ":" + new Date().getMinutes();
      this.fechaHoraAsignacion =
        new Date().toISOString().substr(0, 10) + " " + horaAsignacion;
    },
    autoCompFechaContacto() {
      var horaContacto =
        new Date().getHours() +
        ":" +
        new Date().getMinutes() +
        ":" +
        new Date().getSeconds();
      this.fechaHoraContacto =
        new Date().toISOString().substring(0, 10) + " " + horaContacto;
      this.btnContacto = true;
    },
    autoCompFinalizado() {
      var horaFinalizado =
        new Date().getHours() +
        ":" +
        new Date().getMinutes() +
        ":" +
        new Date().getSeconds();
      this.termino =
        new Date().toISOString().substring(0, 10) + " " + horaFinalizado;
      this.btnFinalizado = true;
    },
    autoCompCierreFinalizado() {
      var horaCierreFinalizado =
        new Date().getHours() +
        ":" +
        new Date().getMinutes() +
        ":" +
        new Date().getSeconds();
      this.fechaHoraCierreAsistencia =
        new Date().toISOString().substring(0, 10) + " " + horaCierreFinalizado;
      this.btnCierreFinalizado = true;
    },
    listaMunicipioSiniestro() {
      this.list_muniSiniestro = [];
      if (this.depaSiniestro === "AHUACHAPAN") {
        this.list_muniSiniestro.push(
          "Ahuachapán",
          "Apaneca",
          "Atiquizaya",
          "Concepción de Ataco",
          "El Refugio",
          "Guaymango",
          "Jujutla",
          "San Francisco Menéndez",
          "San Lorenzo",
          "San Pedro Puxtla",
          "Tacuba",
          "Turín"
        );
        this.colorSiniestro = "#E57373";
      } else if (this.depaSiniestro === "CABAÑAS") {
        this.list_muniSiniestro.push(
          "Sensuntepeque",
          "Cinquera",
          "Dolores",
          "Guacotecti",
          "Ilobasco",
          "Jutiapa",
          "San Isidro",
          "Tejutepeque",
          "Victoria"
        );
        this.colorSiniestro = "#F06292";
      } else if (this.depaSiniestro === "CHALATENANGO") {
        this.list_muniSiniestro.push(
          "Chalatenango",
          "Agua Caliente",
          "Arcatao",
          "Azacualpa",
          "Citalá",
          "Comalapa",
          "Concepción Quezaltepeque",
          "Dulce Nombre de María",
          "El Carrizal",
          "El Paraíso",
          "La Laguna",
          "La Palma",
          "La Reina",
          "Las Vueltas",
          "Nombre de Jesús",
          "Nueva Concepción",
          "Nueva Trinidad",
          "Ojos de Agua",
          "Potonico",
          "San Antonio de La Cruz",
          "San Antonio Los Ranchos",
          "San Fernando",
          "San Francisco Lempa",
          "San Francisco Morazán",
          "San Ignacio",
          "San Isidro Labrador",
          "San José Cancasque",
          "San José Las Flores",
          "San Luis del Carmen",
          "San Miguel de Mercedes",
          "San Rafael",
          "Santa Rita",
          "Tejutla"
        );
        this.colorSiniestro = "#BA68C8";
      } else if (this.depaSiniestro === "CUSCATLAN") {
        this.list_muniSiniestro.push(
          "Cojutepeque",
          "Candelaria",
          "El Carmen",
          "El Rosario",
          "Monte San Juan",
          "Oratorio de Concepción",
          "San Bartolomé Perulapía",
          "San Cristóbal",
          "San José Guayabal",
          "San Pedro Perulapán",
          "San Rafael Cedros",
          "San Ramón",
          "Santa Cruz Analquito",
          "Santa Cruz Michapa",
          "Suchitoto",
          "Tenancingo"
        );
        this.colorSiniestro = "#9575CD";
      } else if (this.depaSiniestro === "LA LIBERTAD") {
        this.list_muniSiniestro.push(
          "Santa Tecla",
          "Antiguo Cuscatlán",
          "Chiltiupán",
          "Ciudad Arce",
          "Colón",
          "Comasagua",
          "Huizúcar",
          "Jayaque",
          "Jicalapa",
          "Nuevo Cuscatlán",
          "Puerto de la Libertad",
          "Quezaltepeque",
          "Sacacoyo",
          "San José Villanueva",
          "San Juan Opico",
          "San Matías",
          "San Pablo Tacachico",
          "Talnique",
          "Tamanique",
          "Teotepeque",
          "Tepecoyo",
          "Zaragoza"
        );
        this.colorSiniestro = "#7986CB";
      } else if (this.depaSiniestro === "LA PAZ") {
        this.list_muniSiniestro.push(
          "Zacatecoluca",
          "Cuyultitán",
          "El Rosario",
          "Jerusalén",
          "Mercedes La Ceiba",
          "Olocuilta",
          "Paraíso de Osorio",
          "San Antonio Masahuat",
          "San Emigdio",
          "San Francisco Chinameca",
          "San Juan Nonualco",
          "San Juan Talpa",
          "San Juan Tepezontes",
          "San Luis La Herradura",
          "San Luis Talpa",
          "San Miguel Tepezontes",
          "San Pedro Masahuat",
          "San Pedro Nonualco",
          "San Rafael Obrajuelo",
          "Santa María Ostuma",
          "Santiago Nonualco",
          "Tapalhuaca"
        );
        this.colorSiniestro = "#64B5F6";
      } else if (this.depaSiniestro === "LA UNION") {
        this.list_muniSiniestro.push(
          "La Unión",
          "Anamorós",
          "Bolívar",
          "Concepción de Oriente",
          "Conchagua",
          "El Carmen",
          "El Sauce",
          "Intipucá",
          "Lislique",
          "Meanguera del Golfo",
          "Nueva Esparta",
          "Pasaquina",
          "Polorós",
          "San Alejo",
          "San José La Fuente",
          "Santa Rosa de Lima",
          "Yayantique",
          "Yucuaiquín"
        );
        this.colorSiniestro = "#4FC3F7";
      } else if (this.depaSiniestro === "MORAZAN") {
        this.list_muniSiniestro.push(
          "San Francisco Gotera",
          "Arambala",
          "Cacaopera",
          "Chilanga",
          "Corinto",
          "Delicias de Concepción",
          "El Divisadero",
          "El Rosario",
          "Gualococti",
          "Guatajiagua",
          "Joateca",
          "Jocoaitique",
          "Jocoro",
          "Lolotiquillo",
          "Meanguera",
          "Osicala",
          "Perquín",
          "San Carlos",
          "San Fernando",
          "San Isidro",
          "San Simón",
          "Sensembra",
          "Sociedad",
          "Torola",
          "Yamabal",
          "Yoloaiquín"
        );
        this.colorSiniestro = "#4DD0E1";
      } else if (this.depaSiniestro === "SAN MIGUEL") {
        this.list_muniSiniestro.push(
          "San Miguel",
          "Carolina",
          "Chapeltique",
          "Chinameca",
          "Chirilagua",
          "Ciudad Barrios",
          "Comacarán",
          "El Tránsito",
          "Lolotique",
          "Moncagua",
          "Nueva Guadalupe",
          "Nuevo Edén de San Juan",
          "Quelepa",
          "San Antonio del Mosco",
          "San Gerardo",
          "San Jorge",
          "San Luis de La Reina",
          "San Rafael Oriente",
          "Sesori",
          "Uluazapa"
        );
        this.colorSiniestro = "#4DB6AC";
      } else if (this.depaSiniestro === "SAN SALVADOR") {
        this.list_muniSiniestro.push(
          "San Salvador",
          "Aguilares",
          "Apopa",
          "Ayutuxtepeque",
          "Ciudad Delgado",
          "Cuscatancingo",
          "El Paisnal",
          "Guazapa",
          "Ilopango",
          "Mejicanos",
          "Nejapa",
          "Panchimalco",
          "Rosario de Mora",
          "San Marcos",
          "San Martín",
          "Santiago Texacuangos",
          "Santo Tomás",
          "Soyapango",
          "Tonacatepeque"
        );
        this.colorSiniestro = "#81C784";
      } else if (this.depaSiniestro === "SAN VICENTE") {
        this.list_muniSiniestro.push(
          "San Vicente",
          "Apastepeque",
          "Guadalupe",
          "San Cayetano Istepeque",
          "San Esteban Catarina",
          "San Ildefonso",
          "San Lorenzo",
          "San Sebastián",
          "Santa Clara",
          "Santo Domingo",
          "Tecoluca",
          "Tepetitán",
          "Verapaz"
        );
        this.colorSiniestro = "#AED581";
      } else if (this.depaSiniestro === "SANTA ANA") {
        this.list_muniSiniestro.push(
          "Santa Ana",
          "Candelaria de la Frontera",
          "Chalchuapa",
          "Coatepeque",
          "El Congo",
          "El Porvenir",
          "Masahuat",
          "Metapán",
          "San Antonio Pajonal",
          "San Sebastián Salitrillo",
          "Santa Rosa Guachipilín",
          "Santiago de la Frontera",
          "Texistepeque"
        );
        this.colorSiniestro = "#DCE775";
      } else if (this.depaSiniestro === "SONSONATE") {
        this.list_muniSiniestro.push(
          "Sonsonate",
          "Acajutla",
          "Armenia",
          "Caluco",
          "Cuisnahuat",
          "Izalco",
          "Juayúa",
          "Nahulingo",
          "Nahuizalco",
          "Salcoatitán",
          "San Antonio del Monte",
          "San Julián",
          "Santa Catarina Masahuat",
          "Santa Isabel Ishuatán",
          "Santo Domingo de Guzmán",
          "Sonzacate"
        );
        this.colorSiniestro = "#FFF176";
      } else if (this.depaSiniestro === "USULUTAN") {
        this.list_muniSiniestro.push(
          "Usulután",
          "Alegría",
          "Berlín",
          "California",
          "Concepción Batres",
          "El Triunfo",
          "Ereguayquín",
          "Estanzuelas",
          "Jiquilisco",
          "Jucuapa",
          "Jucuarán",
          "Mercedes Umaña",
          "Nueva Granada",
          "Ozatlán",
          "Puerto El Triunfo",
          "San Agustín",
          "San Buenaventura",
          "San Dionisio",
          "San Francisco Javier",
          "Santa Elena",
          "Santa María",
          "Santiago de María",
          "Tecapán"
        );
        this.colorSiniestro = "#FFD54F";
      } else if (this.depaSiniestro === "NO REQUERIDO") {
        this.list_muniSiniestro.push("NO REQUERIDO");
      }
    },
    listaMunicipioOrigen() {
      this.list_muniOrigen = [];
      if (this.depaOrigen === "AHUACHAPAN") {
        this.list_muniOrigen.push(
          "Ahuachapán",
          "Apaneca",
          "Atiquizaya",
          "Concepción de Ataco",
          "El Refugio",
          "Guaymango",
          "Jujutla",
          "San Francisco Menéndez",
          "San Lorenzo",
          "San Pedro Puxtla",
          "Tacuba",
          "Turín"
        );
        this.colorOrigen = "#E57373";
      } else if (this.depaOrigen === "CABAÑAS") {
        this.list_muniOrigen.push(
          "Sensuntepeque",
          "Cinquera",
          "Dolores",
          "Guacotecti",
          "Ilobasco",
          "Jutiapa",
          "San Isidro",
          "Tejutepeque",
          "Victoria"
        );
        this.colorOrigen = "#F06292";
      } else if (this.depaOrigen === "CHALATENANGO") {
        this.list_muniOrigen.push(
          "Chalatenango",
          "Agua Caliente",
          "Arcatao",
          "Azacualpa",
          "Citalá",
          "Comalapa",
          "Concepción Quezaltepeque",
          "Dulce Nombre de María",
          "El Carrizal",
          "El Paraíso",
          "La Laguna",
          "La Palma",
          "La Reina",
          "Las Vueltas",
          "Nombre de Jesús",
          "Nueva Concepción",
          "Nueva Trinidad",
          "Ojos de Agua",
          "Potonico",
          "San Antonio de La Cruz",
          "San Antonio Los Ranchos",
          "San Fernando",
          "San Francisco Lempa",
          "San Francisco Morazán",
          "San Ignacio",
          "San Isidro Labrador",
          "San José Cancasque",
          "San José Las Flores",
          "San Luis del Carmen",
          "San Miguel de Mercedes",
          "San Rafael",
          "Santa Rita",
          "Tejutla"
        );
        this.colorOrigen = "#BA68C8";
      } else if (this.depaOrigen === "CUSCATLAN") {
        this.list_muniOrigen.push(
          "Cojutepeque",
          "Candelaria",
          "El Carmen",
          "El Rosario",
          "Monte San Juan",
          "Oratorio de Concepción",
          "San Bartolomé Perulapía",
          "San Cristóbal",
          "San José Guayabal",
          "San Pedro Perulapán",
          "San Rafael Cedros",
          "San Ramón",
          "Santa Cruz Analquito",
          "Santa Cruz Michapa",
          "Suchitoto",
          "Tenancingo"
        );
        this.colorOrigen = "#9575CD";
      } else if (this.depaOrigen === "LA LIBERTAD") {
        this.list_muniOrigen.push(
          "Santa Tecla",
          "Antiguo Cuscatlán",
          "Chiltiupán",
          "Ciudad Arce",
          "Colón",
          "Comasagua",
          "Huizúcar",
          "Jayaque",
          "Jicalapa",
          "Nuevo Cuscatlán",
          "Puerto de la Libertad",
          "Quezaltepeque",
          "Sacacoyo",
          "San José Villanueva",
          "San Juan Opico",
          "San Matías",
          "San Pablo Tacachico",
          "Talnique",
          "Tamanique",
          "Teotepeque",
          "Tepecoyo",
          "Zaragoza"
        );
        this.colorOrigen = "#7986CB";
      } else if (this.depaOrigen === "LA PAZ") {
        this.list_muniOrigen.push(
          "Zacatecoluca",
          "Cuyultitán",
          "El Rosario",
          "Jerusalén",
          "Mercedes La Ceiba",
          "Olocuilta",
          "Paraíso de Osorio",
          "San Antonio Masahuat",
          "San Emigdio",
          "San Francisco Chinameca",
          "San Juan Nonualco",
          "San Juan Talpa",
          "San Juan Tepezontes",
          "San Luis La Herradura",
          "San Luis Talpa",
          "San Miguel Tepezontes",
          "San Pedro Masahuat",
          "San Pedro Nonualco",
          "San Rafael Obrajuelo",
          "Santa María Ostuma",
          "Santiago Nonualco",
          "Tapalhauca"
        );
        this.colorOrigen = "#64B5F6";
      } else if (this.depaOrigen === "LA UNION") {
        this.list_muniOrigen.push(
          "La Unión",
          "Anamorós",
          "Bolívar",
          "Concepción de Oriente",
          "Conchagua",
          "El Carmen",
          "El Sauce",
          "Intipucá",
          "Lislique",
          "Meanguera del Golfo",
          "Nueva Esparta",
          "Pasaquina",
          "Polorós",
          "San Alejo",
          "San José La Fuente",
          "Santa Rosa de Lima",
          "Yayantique",
          "Yucuaiquín"
        );
        this.colorOrigen = "#4FC3F7";
      } else if (this.depaOrigen === "MORAZAN") {
        this.list_muniOrigen.push(
          "San Francisco Gotera",
          "Arambala",
          "Cacaopera",
          "Chilanga",
          "Corinto",
          "Delicias de Concepción",
          "El Divisadero",
          "El Rosario",
          "Gualococti",
          "Guatajiagua",
          "Joateca",
          "Jocoaitique",
          "Jocoro",
          "Lolotiquillo",
          "Meanguera",
          "Osicala",
          "Perquín",
          "San Carlos",
          "San Fernando",
          "San Isidro",
          "San Simón",
          "Sensembra",
          "Sociedad",
          "Torola",
          "Yamabal",
          "Yoloaiquín"
        );
        this.colorOrigen = "#4DD0E1";
      } else if (this.depaOrigen === "SAN MIGUEL") {
        this.list_muniOrigen.push(
          "San Miguel",
          "Carolina",
          "Chapeltique",
          "Chinameca",
          "Chirilagua",
          "Ciudad Barrios",
          "Comacarán",
          "El Tránsito",
          "Lolotique",
          "Moncagua",
          "Nueva Guadalupe",
          "Nuevo Edén de San Juan",
          "Quelepa",
          "San Antonio del Mosco",
          "San Gerardo",
          "San Jorge",
          "San Luis de La Reina",
          "San Rafael Oriente",
          "Sesori",
          "Uluazapa"
        );
        this.colorOrigen = "#4DB6AC";
      } else if (this.depaOrigen === "SAN SALVADOR") {
        this.list_muniOrigen.push(
          "San Salvador",
          "Aguilares",
          "Apopa",
          "Ayutuxtepeque",
          "Ciudad Delgado",
          "Cuscatancingo",
          "El Paisnal",
          "Guazapa",
          "Ilopango",
          "Mejicanos",
          "Nejapa",
          "Panchimalco",
          "Rosario de Mora",
          "San Marcos",
          "San Martín",
          "Santiago Texacuangos",
          "Santo Tomás",
          "Soyapango",
          "Tonacatepeque"
        );
        this.colorOrigen = "#81C784";
      } else if (this.depaOrigen === "SAN VICENTE") {
        this.list_muniOrigen.push(
          "San Vicente",
          "Apastepeque",
          "Guadalupe",
          "San Cayetano Istepeque",
          "San Esteban Catarina",
          "San Ildefonso",
          "San Lorenzo",
          "San Sebastián",
          "Santa Clara",
          "Santo Domingo",
          "Tecoluca",
          "Tepetitán",
          "Verapaz"
        );
        this.colorOrigen = "#AED581";
      } else if (this.depaOrigen === "SANTA ANA") {
        this.list_muniOrigen.push(
          "Santa Ana",
          "Candelaria de la Frontera",
          "Chalchuapa",
          "Coatepeque",
          "El Congo",
          "El Porvenir",
          "Masahuat",
          "Metapán",
          "San Antonio Pajonal",
          "San Sebastián Salitrillo",
          "Santa Rosa Guachipilín",
          "Santiago de la Frontera",
          "Texistepeque"
        );
        this.colorOrigen = "#DCE775";
      } else if (this.depaOrigen === "SONSONATE") {
        this.list_muniOrigen.push(
          "Sonsonate",
          "Acajutla",
          "Armenia",
          "Caluco",
          "Cuisnahuat",
          "Izalco",
          "Juayúa",
          "Nahulingo",
          "Nahuizalco",
          "Salcoatitán",
          "San Antonio del Monte",
          "San Julián",
          "Santa Catarina Masahuat",
          "Santa Isabel Ishuatán",
          "Santo Domingo de Guzmán",
          "Sonzacate"
        );
        this.colorOrigen = "#FFF176";
      } else if (this.depaOrigen === "USULUTAN") {
        this.list_muniOrigen.push(
          "Usulután",
          "Alegría",
          "Berlín",
          "California",
          "Concepción Batres",
          "El Triunfo",
          "Ereguayquín",
          "Estanzuelas",
          "Jiquilisco",
          "Jucuapa",
          "Jucuarán",
          "Mercedes Umaña",
          "Nueva Granada",
          "Ozatlán",
          "Puerto El Triunfo",
          "San Agustín",
          "San Buenaventura",
          "San Dionisio",
          "San Francisco Javier",
          "Santa Elena",
          "Santa María",
          "Santiago de María",
          "Tecapán"
        );
        this.colorOrigen = "#FFD54F";
      } else if (this.depaOrigen == "NO REQUERIDO") {
        this.list_muniOrigen.push("NO REQUERIDO");
      }
    },
    listaMunicipioDestino() {
      this.list_muniDestino = [];
      if (this.depaDestino === "AHUACHAPAN") {
        this.list_muniDestino.push(
          "Ahuachapán",
          "Apaneca",
          "Atiquizaya",
          "Concepción de Ataco",
          "El Refugio",
          "Guaymango",
          "Jujutla",
          "San Francisco Menéndez",
          "San Lorenzo",
          "San Pedro Puxtla",
          "Tacuba",
          "Turín"
        );
        this.colorDestino = "#E57373";
      } else if (this.depaDestino === "CABAÑAS") {
        this.list_muniDestino.push(
          "Sensuntepeque",
          "Cinquera",
          "Dolores",
          "Guacotecti",
          "Ilobasco",
          "Jutiapa",
          "San Isidro",
          "Tejutepeque",
          "Victoria"
        );
        this.colorDestino = "#F06292";
      } else if (this.depaDestino === "CHALATENANGO") {
        this.list_muniDestino.push(
          "Chalatenango",
          "Agua Caliente",
          "Arcatao",
          "Azacualpa",
          "Citalá",
          "Comalapa",
          "Concepción Quezaltepeque",
          "Dulce Nombre de María",
          "El Carrizal",
          "El Paraíso",
          "La Laguna",
          "La Palma",
          "La Reina",
          "Las Vueltas",
          "Nombre de Jesús",
          "Nueva Concepción",
          "Nueva Trinidad",
          "Ojos de Agua",
          "Potonico",
          "San Antonio de La Cruz",
          "San Antonio Los Ranchos",
          "San Fernando",
          "San Francisco Lempa",
          "San Francisco Morazán",
          "San Ignacio",
          "San Isidro Labrador",
          "San José Cancasque",
          "San José Las Flores",
          "San Luis del Carmen",
          "San Miguel de Mercedes",
          "San Rafael",
          "Santa Rita",
          "Tejutla"
        );
        this.colorDestino = "#BA68C8";
      } else if (this.depaDestino === "CUSCATLAN") {
        this.list_muniDestino.push(
          "Cojutepeque",
          "Candelaria",
          "El Carmen",
          "El Rosario",
          "Monte San Juan",
          "Oratorio de Concepción",
          "San Bartolomé Perulapía",
          "San Cristóbal",
          "San José Guayabal",
          "San Pedro Perulapán",
          "San Rafael Cedros",
          "San Ramón",
          "Santa Cruz Analquito",
          "Santa Cruz Michapa",
          "Suchitoto",
          "Tenancingo"
        );
        this.colorDestino = "#9575CD";
      } else if (this.depaDestino === "LA LIBERTAD") {
        this.list_muniDestino.push(
          "Santa Tecla",
          "Antiguo Cuscatlán",
          "Chiltiupán",
          "Ciudad Arce",
          "Colón",
          "Comasagua",
          "Huizúcar",
          "Jayaque",
          "Jicalapa",
          "Nuevo Cuscatlán",
          "Puerto de la Libertad",
          "Quezaltepeque",
          "Sacacoyo",
          "San José Villanueva",
          "San Juan Opico",
          "San Matías",
          "San Pablo Tacachico",
          "Talnique",
          "Tamanique",
          "Teotepeque",
          "Tepecoyo",
          "Zaragoza"
        );
        this.colorDestino = "#7986CB";
      } else if (this.depaDestino === "LA PAZ") {
        this.list_muniDestino.push(
          "Zacatecoluca",
          "Cuyultitán",
          "El Rosario",
          "Jerusalén",
          "Mercedes La Ceiba",
          "Olocuilta",
          "Paraíso de Osorio",
          "San Antonio Masahuat",
          "San Emigdio",
          "San Francisco Chinameca",
          "San Juan Nonualco",
          "San Juan Talpa",
          "San Juan Tepezontes",
          "San Luis La Herradura",
          "San Luis Talpa",
          "San Miguel Tepezontes",
          "San Pedro Masahuat",
          "San Pedro Nonualco",
          "San Rafael Obrajuelo",
          "Santa María Ostuma",
          "Santiago Nonualco",
          "Tapalhauca"
        );
        this.colorDestino = "#64B5F6";
      } else if (this.depaDestino === "LA UNION") {
        this.list_muniDestino.push(
          "La Unión",
          "Anamorós",
          "Bolívar",
          "Concepción de Oriente",
          "Conchagua",
          "El Carmen",
          "El Sauce",
          "Intipucá",
          "Lislique",
          "Meanguera del Golfo",
          "Nueva Esparta",
          "Pasaquina",
          "Polorós",
          "San Alejo",
          "San José La Fuente",
          "Santa Rosa de Lima",
          "Yayantique",
          "Yucuaiquín"
        );
        this.colorDestino = "#4FC3F7";
      } else if (this.depaDestino === "MORAZAN") {
        this.list_muniDestino.push(
          "San Francisco Gotera",
          "Arambala",
          "Cacaopera",
          "Chilanga",
          "Corinto",
          "Delicias de Concepción",
          "El Divisadero",
          "El Rosario",
          "Gualococti",
          "Guatajiagua",
          "Joateca",
          "Jocoaitique",
          "Jocoro",
          "Lolotiquillo",
          "Meanguera",
          "Osicala",
          "Perquín",
          "San Carlos",
          "San Fernando",
          "San Isidro",
          "San Simón",
          "Sensembra",
          "Sociedad",
          "Torola",
          "Yamabal",
          "Yoloaiquín"
        );
        this.colorDestino = "#4DD0E1";
      } else if (this.depaDestino === "SAN MIGUEL") {
        this.list_muniDestino.push(
          "San Miguel",
          "Carolina",
          "Chapeltique",
          "Chinameca",
          "Chirilagua",
          "Ciudad Barrios",
          "Comacarán",
          "El Tránsito",
          "Lolotique",
          "Moncagua",
          "Nueva Guadalupe",
          "Nuevo Edén de San Juan",
          "Quelepa",
          "San Antonio del Mosco",
          "San Gerardo",
          "San Jorge",
          "San Luis de La Reina",
          "San Rafael Oriente",
          "Sesori",
          "Uluazapa"
        );
        this.colorDestino = "#4DB6AC";
      } else if (this.depaDestino === "SAN SALVADOR") {
        this.list_muniDestino.push(
          "San Salvador",
          "Aguilares",
          "Apopa",
          "Ayutuxtepeque",
          "Ciudad Delgado",
          "Cuscatancingo",
          "El Paisnal",
          "Guazapa",
          "Ilopango",
          "Mejicanos",
          "Nejapa",
          "Panchimalco",
          "Rosario de Mora",
          "San Marcos",
          "San Martín",
          "Santiago Texacuangos",
          "Santo Tomás",
          "Soyapango",
          "Tonacatepeque"
        );
        this.colorDestino = "#81C784";
      } else if (this.depaDestino === "SAN VICENTE") {
        this.list_muniDestino.push(
          "San Vicente",
          "Apastepeque",
          "Guadalupe",
          "San Cayetano Istepeque",
          "San Esteban Catarina",
          "San Ildefonso",
          "San Lorenzo",
          "San Sebastián",
          "Santa Clara",
          "Santo Domingo",
          "Tecoluca",
          "Tepetitán",
          "Verapaz"
        );
        this.colorDestino = "#AED581";
      } else if (this.depaDestino === "SANTA ANA") {
        this.list_muniDestino.push(
          "Santa Ana",
          "Candelaria de la Frontera",
          "Chalchuapa",
          "Coatepeque",
          "El Congo",
          "El Porvenir",
          "Masahuat",
          "Metapán",
          "San Antonio Pajonal",
          "San Sebastián Salitrillo",
          "Santa Rosa Guachipilín",
          "Santiago de la Frontera",
          "Texistepeque"
        );
        this.colorDestino = "#DCE775";
      } else if (this.depaDestino === "SONSONATE") {
        this.list_muniDestino.push(
          "Sonsonate",
          "Acajutla",
          "Armenia",
          "Caluco",
          "Cuisnahuat",
          "Izalco",
          "Juayúa",
          "Nahulingo",
          "Nahuizalco",
          "Salcoatitán",
          "San Antonio del Monte",
          "San Julián",
          "Santa Catarina Masahuat",
          "Santa Isabel Ishuatán",
          "Santo Domingo de Guzmán",
          "Sonzacate"
        );
        this.colorDestino = "#FFF176";
      } else if (this.depaDestino === "USULUTAN") {
        this.list_muniDestino.push(
          "Usulután",
          "Alegría",
          "Berlín",
          "California",
          "Concepción Batres",
          "El Triunfo",
          "Ereguayquín",
          "Estanzuelas",
          "Jiquilisco",
          "Jucuapa",
          "Jucuarán",
          "Mercedes Umaña",
          "Nueva Granada",
          "Ozatlán",
          "Puerto El Triunfo",
          "San Agustín",
          "San Buenaventura",
          "San Dionisio",
          "San Francisco Javier",
          "Santa Elena",
          "Santa María",
          "Santiago de María",
          "Tecapán"
        );
        this.colorDestino = "#FFD54F";
      } else if (this.depaDestino === "NO REQUERIDO") {
        this.list_muniDestino.push("NO REQUERIDO");
      }
    },
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 20;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
    verificarAsignacion() {
      if (
        this.fechaHoraAsignacion != null &&
        this.$store.state.usuario.nombre != "IVAN GRACIAS" &&
        this.$store.state.usuario.nombre != "BRENDA HERNANDEZ" &&
        this.$store.state.usuario.nombre != "JOSE ATILIO HERNANDEZ" &&
        this.$store.state.usuario.nombre != "Andrea Margarita Zaldivar Campos"
      ) {
        this.textFieldAsignacionDisabled = true;
      } else {
        this.textFieldAsignacionDisabled = false;
      }
    },
    verificarFechaContacto() {
      if (
        this.fechaHoraContacto != null &&
        this.$store.state.usuario.nombre != "IVAN GRACIAS" &&
        this.$store.state.usuario.nombre != "JOSE ATILIO HERNANDEZ" &&
        this.$store.state.usuario.nombre != "BRENDA HERNANDEZ"
      ) {
        this.btnContacto = true;
        this.textFieldContactoDisabled = true;
      } else {
        this.btnContacto = false;
        this.textFieldContactoDisabled = false;
      }
    },
    verificarFinalizado() {
      if (
        this.termino != null &&
        this.$store.state.usuario.nombre != "IVAN GRACIAS" &&
        this.$store.state.usuario.nombre != "JOSE ATILIO HERNANDEZ" &&
        this.$store.state.usuario.nombre != "BRENDA HERNANDEZ"
      ) {
        this.btnFinalizado = true;
        this.textFieldTerminoDisabled = true;
      } else {
        this.btnFinalizado = false;
        this.textFieldTerminoDisabled = false;
      }
    },
    verificarCierreFinalizado() {
      if (
        this.fechaHoraCierreAsistencia != null &&
        this.$store.state.usuario.nombre != "IVAN GRACIAS" &&
        this.$store.state.usuario.nombre != "JOSE ATILIO HERNANDEZ" &&
        this.$store.state.usuario.nombre != "BRENDA HERNANDEZ"
      ) {
        this.btnCierreFinalizado = true;
        this.textFieldCierreDisabled = true;
      } else {
        this.btnCierreFinalizado = false;
        this.textFieldCierreDisabled = false;
      }
    },
    verificaCostoServicio() {
      if (this.costoServicio > 0 || this.costoServicio < 0) {
        this.costoValid = true;
      } else if (this.costoServicio == 0) {
        this.costoValid = false;
      }
    },
    //////////////////////////// ALMACENAMIENTO DE IMAGENES
    cargarArchivos() {
      this.imagenesPreview = [];
      this.filesDescargadasAudios = [];
      this.bandera = 1;
      this.mostrarBotonDescargar = false;
      if (this.filesCargadas.length > 0) {
        this.disabledCargarArchivos = false;
        for (var i = 0; i < this.filesCargadas.length; i++) {
          if (this.filesCargadas[i].type == "audio/mpeg") {
            this.filesDescargadasAudios.push({
              url: URL.createObjectURL(this.filesCargadas[i]),
            });
          } else {
            if (this.filesCargadas[i].type == "application/pdf") {
              this.filesPDF.push({
                url: URL.createObjectURL(this.filesCargadas[i]),
              });
            } else {
              this.imagenesPreview.push({
                url: URL.createObjectURL(this.filesCargadas[i]),
              });
            }
          }
        }
      } else {
        this.disabledCargarArchivos = true;
      }
    },
    subirArchivos() {
      let me = this;
      me.overlayArchivos = true;
      for (var i = 0; i < me.filesCargadas.length; i++) {
        const storeRef = storage.child(
          me.numeroAsistencia + "/" + me.filesCargadas[i].name
        );
        const subir = storeRef
          .put(me.filesCargadas[i])
          .then(function (snapshot) {
            me.filesCargadas = [];
            me.imagenesPreview = [];
            me.filesDescargadasAudios = [];
            me.filesPDF = [];
            if (i + 1 == me.filesCargadas.length) {
            } else {
              me.snackArchivoSubido = true;
              me.overlayArchivos = false;
              me.cargarArchivos();
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    contarArchivosDescarga() {
      let me = this;
      if (me.numeroAsistencia == "") {
        return;
      }
      me.overlayArchivos = true;
      const contador = storage
        .child(me.numeroAsistencia)
        .listAll()
        .then(function (listAll) {
          var tamañoLista = listAll.items.length;
          for (var i = 0; i < tamañoLista; i++) {
            var auxPath = listAll.items[i].location.path;
            var splitPath = auxPath.split("/");
            me.listaArchivos[i] = splitPath[2];
          }
          tamañoLista = 0;
          auxPath = null;
          splitPath = [];
          me.descargarArchivos();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    descargarArchivos() {
      let me = this;
      me.imagenesPreview = [];
      me.filesDescargadasAudios = [];
      me.filesPDF = [];
      me.bandera = 0;
      me.mostrarBotonDescargar = true;
      for (let i = 0; i < me.listaArchivos.length; i++) {
        var auxListaArchivos = me.listaArchivos[i];
        let splitListaArchivos = auxListaArchivos.split(".");

        const storeRefUrl = storage
          .child(me.numeroAsistencia + "/" + me.listaArchivos[i])
          .getDownloadURL()
          .then(function (url) {
            switch (splitListaArchivos[splitListaArchivos.length - 1]) {
              case "jpg":
              case "JPG":
              case "png":
              case "PNG":
              case "jpeg":
              case "JPEG":
              case "tiff":
              case "TIFF":
              case "bmp":
              case "BMP":
                me.imagenesPreview.push({
                  name: me.listaArchivos[i],
                  url: url,
                });
                break;
              case "mp3":
              case "wav":
                me.filesDescargadasAudios.push({
                  name: me.listaArchivos[i],
                  url: url,
                });
                break;
              case "pdf":
                me.filesPDF.push({
                  name: me.listaArchivos[i],
                  url: url,
                });
                break;
              default:
                break;
            }
          })
          .catch(function (error) {
            console.log("ERROR URL", error);
          });
      }
      me.overlayArchivos = false;
    },
    verImagen(item) {
      this.dialogVerImagen = true;
      //mostrarlo en el dialog
      this.imagenDialog = item.url;
      this.nombreImagen = item.name;
      if (this.bandera == 1) {
        this.banderaEliminar = false;
      } else {
        this.banderaEliminar = true;
      }
    },
    eliminarImagen() {
      let me = this;
      me.dialogVerImagen = false;
      me.dialogBorrarImagen = false;
      me.overlayArchivos = true;
      const borrar = storage
        .child(me.numeroAsistencia + "/" + me.nombreImagen)
        .delete()
        .then(function () {
          me.overlayArchivos = false;
          me.snackArchivoEliminado = true;
          me.listaArchivos = [];
          me.contarArchivosDescarga();
        })
        .catch(function (error) {
          console.log(error);
          me.overlayArchivos = false;
        });
    },
    descargarZIP() {
      let me = this;
      var FileSaver = require("file-saver");
      var JSZip = require("jszip");
      var zip = new JSZip();
      let imagenes = zip.folder("imagenes");
      me.overlayArchivos = true;

      for (var i = 0; i < me.imagenesPreview.length; i++) {
        let nombre = me.imagenesPreview[i].name;
        let url = me.imagenesPreview[i].url;
        let contentP = me.downloadURLPromise(url);
        imagenes.file(nombre, contentP);
      }
      zip.generateAsync({ type: "blob" }).then(function (content) {
        FileSaver.saveAs(content, me.numeroAsistencia + "_imagenes" + ".zip");
        me.overlayArchivos = false;
      });
    },
    descargarZipAudios() {
      let me = this;
      var FileSaver = require("file-saver");
      var JSZip = require("jszip");
      var zip = new JSZip();
      let audios = zip.folder("audios");
      me.overlayArchivos = true;

      for (var i = 0; i < me.filesDescargadasAudios.length; i++) {
        let nombre = me.filesDescargadasAudios[i].name;
        let url = me.filesDescargadasAudios[i].url;
        let contentP = me.downloadURLPromise(url);
        audios.file(nombre, contentP);
      }
      zip.generateAsync({ type: "blob" }).then(function (content) {
        FileSaver.saveAs(content, me.numeroAsistencia + "_audios" + ".zip");
        me.overlayArchivos = false;
      });
    },
    descargarPDF() {
      let me = this;
      var FileSaver = require("file-saver");
      var JSZip = require("jszip");
      var zip = new JSZip();
      let audios = zip.folder("pdfs");
      me.overlayArchivos = true;

      for (var i = 0; i < me.filesPDF.length; i++) {
        let nombre = me.filesPDF[i].name;
        let url = me.filesPDF[i].url;
        let contentP = me.downloadURLPromise(url);
        audios.file(nombre, contentP);
      }
      zip.generateAsync({ type: "blob" }).then(function (content) {
        FileSaver.saveAs(content, me.numeroAsistencia + "_file" + ".zip");
        me.overlayArchivos = false;
      });
    },
    downloadURLPromise(url) {
      return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", url);
        xhr.responseType = "blob";
        xhr.onreadystatechange = function (evt) {
          if (xhr.readyState === 4) {
            if (xhr.status == 200) {
              resolve(xhr.response);
            } else {
              reject(new Error("Error" + ":" + xhr.status));
            }
          }
        };
        xhr.send();
      });
    },
  },
};
</script>
<style scoped>
.buttons {
  margin: 10%;
  text-align: center;
}

.btn-hover {
  width: 150px;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  margin: 20px;
  height: 36px;
  text-align: center;
  border: none;
  background-size: 300% 100%;

  border-radius: 5px;

  -o-transition: all 0.4s ease-in-out;
  -webkit-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
}

.btn-hover:hover {
  background-position: 100% 0;

  -o-transition: all 0.4s ease-in-out;
  -webkit-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
}

.btn-hover:focus {
  outline: none;
}

.btn-hover.color-4 {
  background-image: linear-gradient(
    to right,
    #fc6076,
    #ff9a44,
    #ef9d43,
    #e75516
  );
  box-shadow: 0 4px 15px 0 rgba(252, 104, 110, 0.75);
}
.no-padding-and-margin {
  margin: 0 auto;
  padding: 0;
}
</style>
